import { SVGProps } from 'react';

/**
 * SVG Icon Components
 * Each icon is a 512x512 viewBox SVG
 */

export const fruitsIcons: Record<string, React.FC<SVGProps<SVGSVGElement>>> = {
  apple: (props) => (
    <svg viewBox="0 0 54 60" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fillRule="nonzero" transform="translate(0 -1)">
        <path
          d="m53 35c0 18-11 25-18 25-5 0-7-2-8-2s-3 2-8 2c-7 0-18-7-18-25 0-16 9-20 18-20h.01c2.7210714-.056151 5.429321.3878799 7.99 1.31h.01c2.560679-.9221201 5.2689286-1.366151 7.99-1.31 9 0 18 4 18 20z"
          fill="#f44335"
        />
        <path
          d="m35 15c-.517 0-1.01.017-1.492.041 8.47.446 16.492 4.859 16.492 19.959 0 16.9-9.691 24.1-16.67 24.919.517.051 1.07.081 1.67.081 7 0 18-7 18-25 0-16-9-20-18-20z"
          fill="#c81e1e"
        />
        <path d="m30.05 17.92c-.9452251-.6564336-1.9658667-1.1969708-3.04-1.61" fill="#f44335" />
        <path
          d="m27 11.38v4.93c-2.560679-.9221201-5.2689286-1.366151-7.99-1.31h-.01c-1.2241705-.4461506-2.339008-1.1484641-3.27-2.06-3.74-3.82-2.49-10.86-2.49-10.86s7.32-.84 11.07 2.98c1.5518369 1.7632915 2.4949983 3.97919481 2.69 6.32z"
          fill="#60a917"
        />
        <path
          d="m24.31 5.06c-3.342-3.4-9.5-3.108-10.81-3 2.434.175 5.691.845 7.81 3 1.5518369 1.7632915 2.4949983 3.97919481 2.69 6.32v4.083c1.0221023.1972022 2.025683.4805465 3 .847v-4.93c-.1950017-2.34080519-1.1381631-4.5567085-2.69-6.32z"
          fill="#549414"
        />
        <path
          d="m5.233 32c-.04213661.0003262-.08424301-.0023472-.126-.008-.263259-.032949-.50263385-.1691646-.66542931-.3786606-.16279547-.209496-.23566621-.4750988-.20257069-.7383394 1.088-8.664 5.916-12.875 14.761-12.875.5522847 0 1 .4477153 1 1s-.4477153 1-1 1c-7.764 0-11.824 3.535-12.776 11.125-.06293869.4995631-.4874881.8744175-.991.875z"
          fill="#f5f5f5"
        />
        <circle cx="5" cy="35" fill="#f5f5f5" r="1" />
        <path
          d="m0 35c0 18.941 11.654 26 19 26 2.4823611.0403251 4.937381-.5228127 7.154-1.641.2685188-.1376874.5457808-.2576115.83-.359.2974261.0938257.5859002.2139675.862.359 2.216619 1.1181873 4.6716389 1.6813251 7.154 1.641 7.346 0 19-7.059 19-26 0-17.357-10.333-21-19-21-2.366601-.0226911-4.7241346.2955759-7 .945v-4.945c0-1.881 0-5.382 3.447-7.1.3197527-.15969771.5300187-.47785053.5515928-.83461336.021574-.35676283-.1488214-.69793492-.447-.89500002-.2981787-.19706511-.6788401-.22008436-.9985928-.06038662-2.0748384.99912503-3.5954787 2.87214909-4.147 5.108-.3815421-.67347673-.84618-1.2963536-1.383-1.854-4.045-4.125-11.579-3.315-11.897-3.278-.439147.05069331-.7929028.38371165-.87.819-.055.308-1.294 7.6 2.763 11.739.193.194.4.376.618.554-7.765.951-15.637 5.652-15.637 20.802zm14.129-31.979c1.889-.081 6.784.006 9.466 2.738 1.3994664 1.58718632 2.2437357 3.58710419 2.405 5.697v3.484c-2.2048914-.6248679-4.4862839-.9385677-6.778-.932-1.0372866-.3929084-1.9828218-.9946746-2.778-1.768-2.644-2.704-2.494-7.385-2.315-9.219zm4.871 12.979c2.5893712-.0514019 5.166739.3652861 7.608 1.23h.01l.03.01c.9987995.3854301 1.9478816.889011 2.827 1.5.2920428.2122786.6758351.2506529 1.0041265.1003998s.5501001-.4658001.5803245-.8255747c.0302243-.3597745-.1358294-.7079056-.434451-.9108251-.281-.2-.574-.387-.876-.567 1.7254177-.370558 3.4862922-.550636 5.251-.537 11.28 0 17 6.393 17 19 0 17.484-10.427 24-17 24-2.1870043.0404965-4.3504479-.4570955-6.3-1.449-.5201905-.3043586-1.1001738-.4923414-1.7-.551-.5998262.0586586-1.1798095.2466414-1.7.551-1.9495521.9919045-4.1129957 1.4894965-6.3 1.449-6.573 0-17-6.516-17-24 0-12.607 5.72-19 17-19z"
          fill="#000"
        />
      </g>
    </svg>
  ),
  orange: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m109.344 114.911c-36.211-15.713-49.913-64.523-49.913-64.523s45.008-23.334 81.219-7.621 31.774 56.652 31.774 56.652-26.869 31.205-63.08 15.492z"
        fill="#57a633"
      />
      <path
        d="m59.435 50.389s13.697 48.809 49.908 64.524 63.08-15.488 63.08-15.488z"
        fill="#407a26"
      />
      <path
        d="m257.103 99.11c41.644-28.665 46.848-93.386 46.848-93.386s-62.314-18.247-103.958 10.418-25.988 79.027-25.988 79.027 41.454 32.606 83.098 3.941z"
        fill="#57a633"
      />
      <path
        d="m174.009 95.176s41.453 32.603 83.096 3.936 46.842-93.386 46.842-93.386z"
        fill="#407a26"
      />
      <circle cx="200.243" cy="276.645" fill="#faa237" r="192.372" />
      <circle cx="200.243" cy="276.645" fill="#faa237" r="192.372" />
      <g fill="#ed851c">
        <circle cx="114.361" cy="155.038" r="15.785" />
        <circle cx="127.012" cy="240.22" r="18.831" />
        <circle cx="82.831" cy="245.971" r="8.249" />
        <circle cx="155.825" cy="135.188" r="9.645" />
        <circle cx="159.443" cy="188.854" r="31.002" />
        <circle cx="86.111" cy="194.531" r="24.345" />
      </g>
      <path
        d="m388.685 315.514-259.926 61.581c-4.302 1.019-6.949 5.414-5.742 9.667 5.23 18.43 13.191 35.408 23.304 50.633-57.557-33.247-96.292-95.445-96.292-166.692 0-89.67 61.352-165.01 144.369-186.334-103.539 3.091-186.527 87.988-186.527 192.276 0 103.821 82.157 187.478 183.377 192.156 92.661 4.282 178.966-61.289 197.437-153.287z"
        opacity=".2"
      />
      <path
        d="m364.646 507.078c94.753-22.449 154.346-115.496 136.252-210.21-.83-4.343-5.167-7.083-9.469-6.063l-337.121 79.87c-4.302 1.019-6.949 5.414-5.742 9.667 26.323 92.764 121.327 149.184 216.08 126.736z"
        fill="#faa237"
      />
      <path
        d="m360.07 487.762c84.026-19.907 137-102.161 121.524-186.139-.814-4.417-5.138-7.272-9.507-6.236l-298.435 70.704c-4.37 1.035-6.953 5.527-5.699 9.839 23.844 81.995 108.091 131.739 192.117 111.832z"
        fill="#fae2a0"
      />
      <path
        d="m300.691 356.474-46.587 75.516c-2.657 4.306-8.486 5.408-12.469 2.287-9.668-7.574-18.197-16.45-25.458-26.508-7.263-10.059-13.003-20.947-17.15-32.508-1.708-4.763 1.171-9.95 6.095-11.116l86.34-20.455c7.397-1.752 13.221 6.314 9.229 12.784z"
        fill="#fab523"
      />
      <path
        d="m325.384 364.618 20.455 86.34c1.166 4.924-2.177 9.824-7.2 10.434-12.192 1.481-24.499 1.236-36.746-.742-12.248-1.977-24.006-5.617-35.113-10.86-4.576-2.16-6.207-7.864-3.55-12.17l46.587-75.516c3.993-6.469 13.815-4.883 15.567 2.514z"
        fill="#fab523"
      />
      <path
        d="m348.604 352.916 75.516 46.587c4.306 2.657 5.408 8.486 2.287 12.469-7.574 9.668-16.45 18.197-26.508 25.458-10.059 7.263-20.947 13.003-32.508 17.15-4.763 1.708-9.95-1.172-11.116-6.095l-20.455-86.34c-1.753-7.396 6.313-13.22 12.784-9.229z"
        fill="#fab523"
      />
      <path
        d="m356.748 328.223 86.34-20.455c4.924-1.166 9.824 2.177 10.434 7.2 1.481 12.192 1.236 24.499-.742 36.746-1.977 12.248-5.617 24.006-10.86 35.113-2.16 4.576-7.864 6.207-12.17 3.55l-75.516-46.587c-6.47-3.992-4.884-13.814 2.514-15.567z"
        fill="#fab523"
      />
      <path
        d="m275.924 356.911c2.786-2.008 12.732-5.745 14.74-2.958 2.008 2.786-4.681 11.04-7.467 13.049-2.786 2.008-6.673 1.378-8.682-1.409-2.008-2.787-1.377-6.674 1.409-8.682z"
        fill="#fade91"
      />
      <path
        d="m308.18 382.44c.55-3.39 4.94-13.065 8.331-12.515 3.39.55 4.497 11.116 3.947 14.507-.55 3.39-3.744 5.693-7.135 5.143-3.39-.55-5.693-3.744-5.143-7.135z"
        fill="#fade91"
      />
      <path
        d="m349.04 377.684c-2.008-2.786-5.745-12.732-2.958-14.74 2.786-2.008 11.04 4.681 13.049 7.467 2.008 2.786 1.378 6.673-1.409 8.682-2.786 2.008-6.673 1.377-8.682-1.409z"
        fill="#fade91"
      />
      <path
        d="m374.57 345.428c-3.39-.55-13.065-4.94-12.515-8.331s11.116-4.497 14.507-3.947c3.39.55 5.693 3.745 5.143 7.135s-3.745 5.693-7.135 5.143z"
        fill="#fade91"
      />
      <path
        d="m326.211 344.847c7.791-1.846 12.611-9.659 10.765-17.45l-28.215 6.685c1.846 7.791 9.658 12.611 17.45 10.765z"
        fill="#fab523"
      />
    </svg>
  ),
  citrus: (props) => (
    <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="#ffd600">
        <path d="m44 24c0 1-1.119 3-2.5 3s-2.5-1.344-2.5-3 1.119-3 2.5-3 2.5 2 2.5 3z" />
        <path d="m42 24c0 19-22.567 19-24.5 19s-11.5-4-11.5-19c0-16 9.567-19 11.5-19s24.5 0 24.5 19z" />
      </g>
      <g>
        <g>
          <path
            d="m18 9c5.42 0 10 6.869 10 15s-4.58 15-10 15-10-6.869-10-15 4.58-15 10-15m0-4c-7.732 0-14 8.507-14 19s6.268 19 14 19 14-8.507 14-19-6.268-19-14-19z"
            fill="#fff59d"
          />
        </g>
        <path d="m17 6.001h2v34h-2z" fill="#fff59d" />
        <path d="m6 22.999h24v2h-24z" fill="#fff59d" />
        <g fill="none" stroke="#fff59d" strokeWidth="2">
          <path d="m27 12.999-9 11-8-11" />
          <path d="m10 34.999 8-11 8 11" />
        </g>
      </g>
      <g fill="#ffa000">
        <circle cx="34" cy="29" r="1" />
        <circle cx="35" cy="33" r="1" />
        <circle cx="38" cy="30" r="1" />
      </g>
    </svg>
  ),
  bananas: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m51.26 299.28-3.95 22.27-20.12 14.41c-7.4-5.47-16.06-12.13-16.19-16.5-.22-7.36 8.97-19.14 8.97-19.14 6.13-3.49 22.42-.62 31.29-1.04z"
        fill="#706a37"
      />
      <path
        d="m401.391 116.429 6.7-13.51c11.16 3.95 21.6 5.06 28.3 8.58 37.83 19.8 63.86 79.77 64.55 115.63 1.77 92.26-35.53 158.02-80.89 200.07-17.22 15.96-47.86 39.58-97.27 42.67-2.42.15-5.51.49-8.83.82l10.17-26.45-15.14-18.98c9.97-13.27 23.98-28.1 34.28-42.06 25.63-22.8 47.36-54.42 61.65-98.69 11.93-36.96 17.91-104.8-7.48-140.61-4.49-6.35-13.54-12.24-21.91-21.06l23.96-2.56z"
        fill="#fff27d"
      />
      <path
        d="m500.942 227.13c-.691-35.861-26.721-95.831-64.551-115.631-6.7-3.52-17.14-4.63-28.3-8.58l-6.7 13.51-1.909 3.85-.063.007c22.448 25.617 37.567 62.354 39.372 87.684 6.553 92.044-27.286 159.65-70.4 204-9.761 10.03-24.142 23.03-44.584 33.088l-9.855 25.632c3.319-.331 6.41-.671 8.83-.821 49.41-3.09 80.05-26.71 97.269-42.669 45.361-42.051 82.66-107.81 80.891-200.07z"
        fill="#ffe33b"
      />
      <path
        d="m143.1 391.229-9.76-18.16c18.84-8.86 54.85-21.82 69.33-26.78 56.09-19.21 104.56-86 118.02-142.83 3.45-14.58 7.37-27.97 21.61-69.29a20.9 20.9 0 0 0 1.01-4.62l16.16 5.25 16.04-11.96h.01c8.37 8.82 17.42 14.71 21.91 21.06 25.39 35.81 19.41 103.65 7.48 140.61-14.29 44.27-36.02 75.89-61.65 98.69-26.86 23.89-58 38.12-89.37 47.1-23.28 6.67-78.15 10.16-128.84-9.78z"
        fill="#fff27d"
      />
      <path
        d="m397.431 143.9c-4.489-6.35-13.54-12.24-21.91-21.06h-.01l-10.722 8c11.83 38.109 3.027 91.233-8.821 121.959-16.735 43.405-40.194 73.764-67.055 95.1-28.15 22.356-60.035 34.828-91.857 42.045-11.822 2.684-31.505 4.131-54.426 2.054l-17.579 28.526c50.691 19.94 105.561 16.45 128.84 9.78 31.37-8.979 62.511-23.21 89.37-47.1 25.63-22.8 47.361-54.421 61.651-98.69 11.929-36.965 17.91-104.805-7.481-140.614z"
        fill="#f9d438"
      />
      <path
        d="m47.311 321.549 3.95-22.27a19.553 19.553 0 0 0 2.79-.3c16.29-3.12 54.9-6.56 73.23-8.37 45.98-4.53 120.49-50.58 147.47-100.36 6.92-12.77 11.59-26.21 35.38-61.26a18.959 18.959 0 0 0 2.08-4.09l28.81 4.55 2.24.08.05.02a20.9 20.9 0 0 1 -1.01 4.62c-14.24 41.32-18.16 54.71-21.61 69.29-13.46 56.83-61.93 123.62-118.02 142.83-14.48 4.96-50.49 17.92-69.33 26.78-4.29 2.02-13.05 3.35-20.74 5.26-20.54-4.11-51.87-15.88-78.32-37.04-1.89-1.51-4.41-3.34-7.09-5.33z"
        fill="#f8ee4f"
      />
      <path
        d="m312.211 124.9c-.539 1.46-30.539 52.58-37.459 65.351-26.981 49.779-101.49 95.829-147.471 100.359-18.33 1.81-56.939 5.25-73.23 8.37a19.394 19.394 0 0 1 -2.789.3l-3.951 22.27s52.07 12.792 92.416 2.886c44.87-11.018 120.49-50.581 147.47-100.36 6.92-12.77 44.6-96.082 44.6-96.082z"
        fill="#fffac1"
      />
      <path
        d="m308.981 425.259 15.14 18.98-10.17 26.45c-9.16.92-20.05 1.81-23.08-1.34-5.11-5.3-6.23-20.19-6.23-20.19 2.45-7.5 19.62-17.63 24.34-23.9z"
        fill="#eadf53"
      />
      <path
        d="m112.6 378.329c7.69-1.91 16.45-3.24 20.74-5.26l9.76 18.16-18.05 29.29c-8.71-3.43-27.23-9.47-29.01-15.33-2.2-7.26 3.78-21.47 3.78-21.47 2.391-2.39 7.321-4.04 12.78-5.39z"
        fill="#706a37"
      />
      <g fill="#8c8448">
        <path d="m408.091 102.919-6.7 13.51-1.91 3.85-23.96 2.56c-9.26-9.75-17.69-23.09-18.23-44.6-.21-8.18 3.42-16.86-5.87-28.15l1.17-.41c15.41 5.56 15.97 15.32 19.99 22.7 9.98 18.34 23.18 26.17 35.51 30.54z" />
        <path d="m375.521 122.839h-.01l-16.04 11.96-16.16-5.25c2.01-17.99-15.16-42.52-15.16-42.52l.03-13.14s-10.81-16.21-3.57-29.37a4.32 4.32 0 0 1 3.53-1.92c0-.01.01 0 .01 0 7.16-.89 21.48 5.46 21.48 5.46.64.69 1.24 1.36 1.79 2.03 9.29 11.29 5.66 19.97 5.87 28.15.54 21.51 8.97 34.85 18.23 44.6z" />
        <path d="m328.151 87.029s17.17 24.53 15.16 42.52l-.05-.02-2.24-.08-28.81-4.55c6.06-16.35-5.98-43.86-5.98-43.86l5.94-12.15s-6.02-17.97 4.1-28.44l11.87 2.15a4.32 4.32 0 0 0 -3.53 1.92c-7.24 13.16 3.57 29.37 3.57 29.37z" />
      </g>
      <path
        d="m439.177 106.185c-4.362-2.283-9.748-3.622-15.451-5.039-14.767-3.668-33.144-8.233-45.877-31.63a48.109 48.109 0 0 1 -1.991-4.383c-2.782-6.675-6.591-15.817-21.229-21.1a6.137 6.137 0 0 0 -.789-.219 5.977 5.977 0 0 0 -1.78-1.238 101.016 101.016 0 0 0 -12.06-4.337c-2.225-.627-6.966-1.96-11.5-1.678l-11.168-2.016a6 6 0 0 0 -5.382 1.736c-10.1 10.455-7.638 25.978-6.167 32.012l-4.946 10.114a6 6 0 0 0 -.107 5.042c3.079 7.033 10.063 27.935 5.877 39.288-.009.026-.02.051-.029.077a13.3 13.3 0 0 1 -1.417 2.809c-18.437 27.167-25.709 41.869-31.018 52.605-1.664 3.365-3.1 6.271-4.672 9.168-26.382 48.671-99.68 93-142.777 97.242-2.654.262-5.733.558-9.108.882-20.093 1.931-50.458 4.848-64.664 7.569a13.743 13.743 0 0 1 -1.779.192c-.067 0-.131.006-.2.009-2.593.119-6.313-.1-9.944-.315-9.024-.535-18.356-1.087-24.006 2.133a6.014 6.014 0 0 0 -1.759 1.522c-1.757 2.252-10.5 13.942-10.23 23.009.214 7.057 8.107 13.4 20.124 22.265 2.037 1.5 3.96 2.923 5.4 4.075 20.882 16.7 44.923 27.819 64.63 34a5.964 5.964 0 0 0 -.878 1.418c-1.138 2.706-6.673 16.655-3.982 25.529 2.2 7.266 13.072 11.841 28.186 17.511 1.612.6 3.1 1.162 4.366 1.662 29.2 11.486 59.716 15.461 85.267 15.461 19.749 0 36.532-2.376 47.422-5.5a257.387 257.387 0 0 0 55.018-22.513c-2.238 2.742-4.394 5.457-6.378 8.1-1.443 1.92-5.235 4.974-8.9 7.928-7.041 5.67-14.321 11.533-16.34 17.714a6.029 6.029 0 0 0 -.279 2.31c.213 2.847 1.593 17.383 7.89 23.911 2.92 3.028 7.687 4.035 14.206 4.035 4.423 0 9.652-.464 15.658-1.075 2.519-.256 4.9-.5 6.739-.613 38.418-2.4 71.449-16.883 100.98-44.263 38.878-36.047 84.8-100.8 82.8-204.586-.688-36.002-26.802-99.387-67.756-120.823zm-75.656-33.071c.137-1.738.284-3.628.29-5.651.326.741.644 1.5.97 2.287a58.171 58.171 0 0 0 2.528 5.5c9.263 17.022 21.056 25.727 32.506 30.843l-4.246 8.569-17.664 1.882c-7.717-8.8-14.164-20.484-14.616-38.458-.038-1.519.094-3.196.232-4.972zm-34.177-24.631c2.91-.169 10.184 1.816 16.715 4.572 6.426 7.306 6 12.8 5.5 19.12a59.252 59.252 0 0 0 -.266 6.215c.366 14.536 4.07 26.942 11.325 37.926 1.307 1.979 2.688 3.833 4.107 5.587l-8.353 6.227-8.923-2.9c-.234-6.939-2.376-14.921-6.429-23.873a125.018 125.018 0 0 0 -8.867-16.141l.03-11.309a6 6 0 0 0 -1.009-3.346c-.084-.124-8.03-12.497-3.83-22.078zm-11.483 18.5a36.449 36.449 0 0 1 -1.347-7.274 47.487 47.487 0 0 0 5.665 15.853l-.031 11.459a6.018 6.018 0 0 0 1.083 3.454c4.021 5.758 12.457 20.3 14.012 32.306l-17.729-2.8c1.978-14.636-4.019-31.933-6.709-38.727l4.757-9.726a6.005 6.005 0 0 0 .299-4.547zm-290.582 261.535c-4.351-3.342-9.323-7.44-10.276-9.55.138-3.31 3.839-9.686 6.822-13.792 3.372-1 11.45-.519 16.468-.222 1.32.078 2.593.152 3.827.215l-2.295 12.931zm10.747 8.089c-.215-.173-.455-.357-.684-.536l11.151-7.987c5.342 1.395 17.654 4.444 31.527 6.734a6 6 0 0 0 1.955-11.839c-11.339-1.872-21.793-4.324-27.794-5.831l2.218-12.5c14.156-2.555 43.035-5.33 62.334-7.184 3.386-.325 6.475-.622 9.138-.884 46.933-4.626 123.618-50.83 152.15-103.467 1.677-3.094 3.232-6.238 4.877-9.566 5.444-11 12.217-24.7 30.193-51.186.188-.278.356-.567.532-.852l20.147 3.184c-13.62 39.615-17.506 52.961-20.922 67.385-12.593 53.193-58.723 119.557-114.119 138.537-12.782 4.379-50.261 17.771-69.939 27.029-2.252 1.06-7.056 2.086-11.7 3.078-2.2.47-4.415.945-6.581 1.458-19.976-4.222-49.589-15.664-74.483-35.573zm84.521 76.538c-5.252-1.97-18.542-6.976-20.832-9.96-.8-3.36 1.212-10.864 3.1-15.81 1.768-1.136 5.162-2.187 8.782-3.1a5.971 5.971 0 0 0 1.159-.287c2.376-.575 4.784-1.09 6.838-1.529 3.254-.7 6.244-1.339 8.873-2.06l5.71 10.628zm129.693 11.386c-21.475 6.148-71.455 9.231-118.234-7.106l12.474-20.243a174.376 174.376 0 0 0 27.954-3.422 6 6 0 0 0 -2.36-11.766 165.333 165.333 0 0 1 -25.423 3.173l-4.982-9.275c20.065-8.789 51.511-20 62.948-23.923 27.184-9.314 54.794-30.358 77.746-59.255 21.149-26.627 37.245-58.654 44.162-87.87 3.36-14.189 7.226-27.412 21.058-67.6l10.034 3.258a6 6 0 0 0 5.44-.9l11.885-8.861c2.691 2.568 5.334 4.863 7.747 6.955 4.168 3.614 7.769 6.736 9.85 9.671 23.856 33.651 18.255 99.377 6.658 135.3-13.12 40.641-33.882 73.483-61.708 97.614-22.982 19.933-50.867 34.406-85.249 44.25zm57.445 40.53c-5.6.48-12.49.855-14.7-.106-2.123-2.543-3.668-9.753-4.218-14.8 1.826-3 8.13-8.08 12.043-11.232 2.047-1.648 3.957-3.193 5.669-4.678l8.809 11.048zm106.291-42.261c-10.04 9.308-40.518 37.551-92.963 41.039l6.707-17.443a6 6 0 0 0 -.909-5.894l-12.206-15.306c3.986-5.064 8.446-10.322 13.123-15.829 6.248-7.358 12.7-14.963 18.176-22.359 28.483-25.526 49.244-58.928 62.713-100.65 11.512-35.66 19.441-106.811-8.289-145.926-2.917-4.115-7.221-7.847-11.778-11.8-.462-.4-.931-.807-1.4-1.216l10.968-1.169a6 6 0 0 0 4.687-3.209c15.919 3.062 30.008 12.939 45.376 45.247a6 6 0 1 0 10.836-5.155c-10.84-22.789-24.553-44.469-50.735-51.127l.879-1.775c3.379 1 6.631 1.809 9.672 2.564 5.2 1.293 9.693 2.409 12.78 4.024 36.507 19.109 60.707 78.166 61.328 110.427 1.912 99.342-41.887 161.176-78.965 195.557z"
        fill="#151515"
      />
    </svg>
  ),
  strawberry: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M278.331,149.454c-5.628,1.853-11.686,3.465-18.205,4.807c0,0-3.605-8.682-5.878-22.13 c-5.047-29.891-3.515-83.364,58.84-117.481c3.725-2.033,7.671-4.005,11.836-5.898c8.101-3.675,17.544,1.142,19.386,9.843 c0.801,3.805,1.592,8.171,2.243,12.958C351.341,67.432,347.576,126.663,278.331,149.454z"
        fill="#368B4C"
      />
      <path
        d="M254.248,132.131c-5.047-29.891-3.515-83.364,58.84-117.481c0.15,0.941,0.29,1.903,0.421,2.884 C318.075,51.801,314.851,107.357,254.248,132.131z"
        fill="#3FA45A"
      />
      <path
        d="M189.349,204.92c-50.379,85.797-125.061,54.084-155.563,35.919 c-7.64-4.556-9.153-15.041-3.064-21.519c5.117-5.447,10.234-10.254,15.331-14.47c61.604-51.03,120.194-16.833,137.889-4.126 C187.447,203.248,189.349,204.92,189.349,204.92z"
        fill="#368B4C"
      />
      <path
        d="M183.942,200.724c-48.206,49.017-107.727,23.132-134.133,7.4c-1.492-0.891-2.754-2.003-3.755-3.274 C107.658,153.82,166.248,188.017,183.942,200.724z"
        fill="#3FA45A"
      />
      <path
        d="M227.081,185.554c-82.333,55.866-136.176-4.837-155.923-34.347 c-4.947-7.39-1.802-17.504,6.479-20.748c6.259-2.453,12.297-4.426,18.115-5.978c68.474-18.305,106.736,22.14,122.568,45.692 C224.297,179.065,227.081,185.554,227.081,185.554z"
        fill="#4CBA68"
      />
      <path
        d="M218.319,170.173c-61.654,23.452-103.542-19.176-122.568-45.692 C164.225,106.175,202.487,146.62,218.319,170.173z"
        fill="#64C37D"
      />
      <path
        d="M230.184,183.787c79.229-60.186,38.895-130.593,17.234-158.729 c-5.424-7.048-16.012-7.297-21.731-0.485c-4.323,5.148-8.12,10.24-11.449,15.258c-39.209,59.046-13.097,108.219,4.168,130.741 C224.923,179.078,230.184,183.787,230.184,183.787z"
        fill="#4CBA68"
      />
      <path
        d="M218.405,170.573c41.909-50.94,14.886-104.245-4.168-130.741 C175.029,98.877,201.141,148.05,218.405,170.573z"
        fill="#64C37D"
      />
      <path
        d="M463.865,458.467c-1.091,2.984-2.363,5.848-3.815,8.602c-12.938,24.574-39.524,39.484-67.793,37.191 c-108.879-8.862-207.223-78.377-207.223-78.377c-78.367-52.011-88.1-164.935-18.515-214.734l2.373-1.692l50.799-36.37l53.173-38.052 c69.585-49.798,173.517-4.216,197.28,86.789C498.202,329.23,481.098,411.312,463.865,458.467z"
        fill="#C70024"
      />
      <path
        d="M463.865,458.467c-1.091,2.984-2.363,5.848-3.815,8.602c-11.536,6.098-24.824,9.012-38.503,7.901 c-108.879-8.862-207.223-78.377-207.223-78.377c-66.08-43.86-83.364-131.019-45.432-187.136l50.799-36.37l53.173-38.052 c69.585-49.798,173.517-4.216,197.28,86.789C498.202,329.23,481.098,411.312,463.865,458.467z"
        fill="#FF0C38"
      />
      <ellipse
        transform="matrix(-0.8132 0.582 -0.582 -0.8132 529.3708 493.4775)"
        cx="185.488"
        cy="331.697"
        rx="9.022"
        ry="16.247"
      />
      <ellipse
        transform="matrix(0.8132 -0.582 0.582 0.8132 -103.9842 173.6438)"
        cx="218.5"
        cy="248.802"
        rx="9.022"
        ry="16.247"
      />
      <ellipse
        transform="matrix(-0.8132 0.582 -0.582 -0.8132 719.1804 373.2432)"
        cx="299.689"
        cy="302.042"
        rx="9.022"
        ry="16.247"
      />
      <ellipse
        transform="matrix(0.8132 -0.582 0.582 0.8132 -26.5242 275.1363)"
        cx="415.329"
        cy="178.886"
        rx="9.022"
        ry="16.247"
      />
      <ellipse
        transform="matrix(-0.582 -0.8132 0.8132 -0.582 391.2289 759.6775)"
        cx="390.863"
        cy="279.287"
        rx="16.247"
        ry="9.022"
      />
      <ellipse
        transform="matrix(-0.8132 0.582 -0.582 -0.8132 1012.7191 402.867)"
        cx="441.704"
        cy="363.964"
        rx="9.022"
        ry="16.247"
      />
      <ellipse
        transform="matrix(0.8132 -0.582 0.582 0.8132 -176.4079 268.6759)"
        cx="330.323"
        cy="409.136"
        rx="9.022"
        ry="16.247"
      />
      <ellipse
        transform="matrix(0.8132 -0.582 0.582 0.8132 -186.1726 322.0207)"
        cx="408.538"
        cy="451.019"
        rx="9.022"
        ry="16.247"
      />
      <ellipse
        transform="matrix(0.8132 -0.582 0.582 0.8132 -196.13 209.0079)"
        cx="227.515"
        cy="410.023"
        rx="9.022"
        ry="16.247"
      />
      <ellipse
        transform="matrix(0.8132 -0.582 0.582 0.8132 -52.0618 221.2629)"
        cx="318.639"
        cy="191.73"
        rx="9.022"
        ry="16.247"
      />
      <path d="M484.513,355.756c-4.156-0.31-7.741,2.794-8.051,6.929c-2.453,32.895-9.062,64.258-19.647,93.207 c-8.982,24.574-32.635,41.086-58.84,41.086c-1.692,0-3.415-0.07-5.107-0.21c-105.484-8.582-202.537-76.334-203.498-77.015 c-0.06-0.05-0.12-0.09-0.18-0.13c-25.525-16.933-44.961-42.138-54.755-70.957c-1.332-3.925-5.598-6.028-9.523-4.696 c-3.925,1.332-6.028,5.598-4.696,9.523c10.835,31.924,32.344,59.822,60.573,78.587c1.953,1.372,26.236,18.265,63.757,36.43 c35.428,17.143,89.703,38.563,147.101,43.229c2.103,0.17,4.226,0.26,6.329,0.26c32.494,0,61.804-20.478,72.94-50.95 c11.065-30.251,17.965-62.976,20.528-97.243C491.743,359.672,488.649,356.067,484.513,355.756z" />
      <path d="M121.587,329.3c4.116-0.481,7.07-4.206,6.589-8.331c-0.581-4.977-0.881-10.014-0.881-14.95 c0-16.946,3.514-32.853,9.111-45.648c13.138-30.661,36.317-44.126,36.992-44.915l0.499-0.349c0.004-0.003,0.011-0.008,0.019-0.014 c-0.007,0.005-0.013,0.01-0.019,0.013l0.001-0.001c0.02-0.014,0.035-0.025,0.048-0.034c0.011-0.008,0.021-0.015,0.036-0.026 c-0.003,0.002-0.007,0.005-0.012,0.009c0.014-0.01,0.018-0.013,0.016-0.011c1.065-0.762,12.124-8.678,103.243-73.898 c65.337-46.782,163.228-3.268,185.654,82.583c9.663,37.001,14.59,73.841,14.64,109.52c0.01,4.146,3.375,7.5,7.51,7.5 c4.137,0,7.52-3.353,7.51-7.52c-0.06-36.951-5.147-75.073-15.131-113.295c-16.583-63.487-72.559-110.081-134.434-112.774 c6.369-12.036,9.683-24.493,11.245-35.869c0.571-4.116-2.303-7.901-6.419-8.462c-4.106-0.571-7.891,2.303-8.462,6.409 c-2.033,14.77-6.739,27.568-14.089,38.392c-15.071,1.492-29.54,5.788-42.789,12.707c0.551-2.724,0.981-5.467,1.292-8.241 c0.471-4.126-2.503-7.841-6.619-8.301c-4.136-0.461-7.841,2.503-8.301,6.629c-0.871,7.761-2.904,15.301-6.088,22.611l-40.796,29.2 c-2.447-3.407-4.408-5.774-5.107-6.659c-8.071-13.198-15.842-31.463-15.842-52.922c0-24.744,10.234-49.408,30.422-73.31 c1.652-1.963,3.765-2.253,4.877-2.253c2.033,0,3.915,0.921,5.147,2.533c5.327,6.97,11.576,16.282,16.803,27.207 c3.977,8.263,7.151,17.033,9.072,26.116c0.861,4.056,4.847,6.649,8.902,5.798c4.056-0.861,6.649-4.847,5.798-8.912 c-1.632-7.67-3.995-14.97-6.799-21.79c10.234-15.621,26.757-30.632,52.802-42.448c0.841-0.381,1.722-0.571,2.614-0.571 c2.604,0,5.608,1.762,6.319,5.127c1.462,6.909,2.483,13.889,3.034,20.728c0.33,4.136,3.935,7.22,8.081,6.889 c4.136-0.33,7.22-3.945,6.889-8.081c-0.601-7.49-1.712-15.111-3.305-22.651C349.568,7.16,340.726,0,330.643,0 c-3.044,0-6.018,0.641-8.822,1.913c-25.114,11.386-42.388,25.515-54.084,40.525c-4.746-8.622-9.843-16.042-14.35-21.94 c-4.106-5.357-10.324-8.432-17.083-8.432c-6.319,0-12.287,2.764-16.352,7.58c-22.541,26.686-33.966,54.615-33.966,83.003 c0,3.875,0.23,7.65,0.631,11.325L153.54,67.763c-2.413-3.375-7.11-4.146-10.484-1.742c-3.365,2.423-4.146,7.11-1.732,10.484 l32.434,45.312c-23.702-10.655-56.427-14.96-98.865,1.652c-6.058,2.373-10.665,7.3-12.617,13.528 c-1.963,6.249-0.991,12.958,2.644,18.385c3.955,5.908,9.363,13.208,16.172,20.668c-19.727,6.819-38.413,19.557-55.846,38.122 c-3.735,3.975-5.788,9.173-5.788,14.63c0,7.66,3.915,14.57,10.484,18.485c6.639,3.955,13.518,7.48,20.428,10.464 c3.815,1.642,8.231-0.11,9.874-3.915c1.642-3.815-0.11-8.231-3.915-9.874c-6.319-2.734-12.617-5.958-18.696-9.583 c-1.983-1.172-3.154-3.254-3.154-5.578c0-1.142,0.29-2.824,1.722-4.346c17.874-19.036,37.031-31.213,57.148-36.38 c16.32,14.27,35.337,24.306,56.587,27.017c-10.984,10.363-19.775,22.718-26.093,36.484c-13.245,3.607-26.931,3.529-40.458,0.907 c-4.076-0.781-8.011,1.873-8.802,5.948c-0.791,4.076,1.873,8.011,5.948,8.802c7.4,1.432,14.74,2.163,21.81,2.163h0.01 c5.217,0,10.304-0.381,15.261-1.132c-3.505,11.916-5.337,24.594-5.337,37.752c0,5.518,0.33,11.135,0.981,16.693 C113.736,326.837,117.471,329.781,121.587,329.3z M114.097,185.233c-6.028-4.116-11.466-8.752-16.312-13.488 c-8.892-8.712-15.742-17.784-20.388-24.714c-1.091-1.632-1.382-3.655-0.781-5.538c0.34-1.091,1.282-3.074,3.755-4.046 c17.274-6.759,33.576-10.134,48.827-10.134c29.048,0,53.826,12.473,72.96,34.187l5.708,7.981c0.441,0.641,0.881,1.272,1.322,1.883 l-40.766,29.18C150.035,202.084,131.761,197.325,114.097,185.233z" />
    </svg>
  ),
  grapes: (props) => (
    <svg viewBox="0 0 511.99 511.99" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="451.47" cy="411.426" r="60.52" fill="#744EAA" />
      <path
        d="M458.328,470.367c-32.552-7.577-52.798-40.109-45.22-72.661 c5.679-24.395,25.372-41.877,48.586-45.918c-31.354-5.403-61.858,14.532-69.164,45.918c-7.577,32.552,12.668,65.083,45.22,72.661 c8.157,1.899,16.312,2.049,24.074,0.698C460.66,470.864,459.494,470.639,458.328,470.367z"
        fill="#67449E"
      />
      <path
        d="M172.053,169.022c1.505,0.35,2.979,0.765,4.429,1.221c0.593-2.533,1.355-4.98,2.241-7.355 C117.938,93.787,42.339,68.364,14.9,61.717C9.09,60.31,3.479,64.38,3.003,70.315l-2.977,37.101c-0.407,5.074,3.959,9.33,9.007,8.745 c62.963-7.295,121.331,24.772,158.144,51.952C168.801,168.353,170.426,168.643,172.053,169.022z"
        fill="#93603E"
      />
      <path
        d="M148.749,133.05C112.325,109.657,62.328,87.631,9.034,93.805c-3.133,0.363-6.001-1.141-7.631-3.545 l-1.377,17.156c-0.407,5.074,3.959,9.33,9.007,8.745c62.963-7.295,121.331,24.772,158.144,51.952 c1.623,0.241,3.249,0.531,4.875,0.909c1.506,0.35,2.979,0.765,4.429,1.22c0.593-2.533,1.355-4.98,2.241-7.355 C169.024,151.862,158.947,141.953,148.749,133.05z"
        fill="#7F573C"
      />
      <path
        d="M83.067,284.142c7.706-9.393,18.096-16.257,29.723-19.645c1.882,2.214-20.481-19.894-12.856-52.653 c5.358-23.018,23.29-39.825,44.841-44.875c-28.386-9.372-68.967-11.869-111.454,13.864c-3.688,2.234-4.446,7.277-1.521,10.445 c5.956,6.453,16.773,16.835,31.348,25.34c3.82,2.229,4.338,7.473,1.036,10.415c-12.046,10.734-23.214,24.926-32.267,43.656 c-1.876,3.881,0.238,8.528,4.415,9.592C45.607,282.642,64.322,285.768,83.067,284.142z"
        fill="#3BBC56"
      />
      <path
        d="M58.169,280.28c-4.177-1.063-6.291-5.711-4.415-9.592c9.053-18.73,20.221-32.922,32.267-43.655 c3.302-2.942,2.784-8.186-1.036-10.415c-14.575-8.505-25.392-18.887-31.348-25.34c-2.925-3.168-2.167-8.211,1.521-10.445 c20.775-12.583,41.09-18.404,59.751-19.984c-24.066-2.056-52.376,2.292-81.588,19.984c-3.688,2.234-4.446,7.277-1.521,10.445 c5.956,6.453,16.773,16.835,31.348,25.34c3.82,2.23,4.338,7.473,1.036,10.415c-12.046,10.734-23.214,24.926-32.267,43.655 c-1.876,3.881,0.238,8.528,4.415,9.592c9.254,2.357,27.905,5.472,46.609,3.87C72.652,283.372,63.717,281.693,58.169,280.28z"
        fill="#30AA44"
      />
      <path
        d="M248.579,125.439c3.422,0.796,6.7,1.881,9.829,3.204c7.702-11.945,19.4-20.697,32.789-24.842 c3.426-23.897-3.962-47.939-7.506-59.05c-1.31-4.107-6.074-5.941-9.837-3.838c-18.159,10.149-31.663,22.139-41.663,34.801 c-2.741,3.471-8.006,3.265-10.458-0.415c-9.356-14.044-20.361-24.226-27.156-29.789c-3.337-2.731-8.325-1.676-10.336,2.138 c-23.516,44.605-17.203,85.46-5.809,113.335C189.447,134.263,219.515,118.674,248.579,125.439z"
        fill="#3BBC56"
      />
      <path
        d="M202.547,52.579c-2.977-2.846-5.709-5.219-7.97-7.069c-3.336-2.731-8.325-1.676-10.336,2.138 c-23.516,44.604-17.203,85.46-5.809,113.335c3.247-7.878,8.161-14.778,14.207-20.433C186.782,115.968,186.741,85.396,202.547,52.579 z"
        fill="#30AA44"
      />
      <circle cx="307.53" cy="160.006" r="60.52" fill="#744EAA" />
      <path
        d="M314.387,218.949c-32.552-7.577-52.798-40.109-45.22-72.661 c5.679-24.395,25.372-41.877,48.586-45.918c-31.354-5.403-61.858,14.532-69.164,45.918c-7.577,32.552,12.668,65.083,45.22,72.661 c8.157,1.899,16.312,2.049,24.074,0.698C316.718,219.446,315.553,219.22,314.387,218.949z"
        fill="#67449E"
      />
      <circle cx="241.01" cy="356.526" r="60.52" fill="#744EAA" />
      <path
        d="M247.873,415.467c-32.552-7.577-52.798-40.109-45.22-72.66c5.679-24.395,25.372-41.877,48.586-45.918 c-31.354-5.403-61.858,14.532-69.164,45.918c-7.577,32.552,12.668,65.083,45.22,72.66c8.157,1.899,16.312,2.049,24.074,0.698 C250.205,415.964,249.039,415.738,247.873,415.467z"
        fill="#67449E"
      />
      <circle cx="127.34" cy="321.726" r="60.52" fill="#744EAA" />
      <path
        d="M134.202,380.664c-32.552-7.577-52.798-40.109-45.22-72.661 c5.679-24.395,25.372-41.877,48.586-45.918c-31.354-5.403-61.858,14.532-69.164,45.918c-7.577,32.552,12.668,65.083,45.22,72.661 c8.157,1.899,16.312,2.049,24.074,0.698C136.533,381.161,135.368,380.935,134.202,380.664z"
        fill="#67449E"
      />
      <circle cx="233.25" cy="181.426" r="60.52" fill="#553788" />
      <path
        d="M240.132,240.368c-32.552-7.577-52.798-40.109-45.22-72.661 c5.678-24.391,25.366-41.871,48.574-45.916c-31.359-5.412-61.872,14.525-69.179,45.916c-7.577,32.552,12.668,65.083,45.22,72.661 c8.161,1.9,16.321,2.049,24.086,0.695C242.453,240.863,241.293,240.638,240.132,240.368z"
        fill="#462E7A"
      />
      <circle cx="319.48" cy="240.436" r="60.06" fill="#9266CC" />
      <path
        d="M326.466,298.931c-32.309-7.521-52.403-39.809-44.883-72.118c5.63-24.185,25.139-41.523,48.145-45.56 c-31.155-5.424-61.49,14.374-68.75,45.56c-7.521,32.309,12.574,64.597,44.883,72.118c8.124,1.891,16.246,2.033,23.974,0.677 C328.712,299.413,327.59,299.193,326.466,298.931z"
        fill="#7B54BA"
      />
      <circle cx="412.2" cy="324.056" r="60.06" fill="#9266CC" />
      <path
        d="M419.185,382.553c-32.309-7.521-52.403-39.809-44.883-72.118c5.63-24.185,25.139-41.523,48.145-45.56 c-31.155-5.424-61.49,14.374-68.75,45.56c-7.521,32.309,12.574,64.597,44.883,72.118c8.124,1.891,16.246,2.033,23.974,0.677 C421.431,383.035,420.309,382.815,419.185,382.553z"
        fill="#7B54BA"
      />
      <circle cx="354" cy="403.526" r="60.06" fill="#9266CC" />
      <path
        d="M360.988,462.024c-32.309-7.521-52.403-39.809-44.883-72.118c5.63-24.185,25.139-41.523,48.145-45.56 c-31.155-5.424-61.49,14.374-68.75,45.56c-7.521,32.309,12.574,64.597,44.883,72.118c8.124,1.891,16.246,2.033,23.974,0.677 C363.234,462.505,362.111,462.285,360.988,462.024z"
        fill="#7B54BA"
      />
      <circle cx="156.37" cy="225.466" r="60.06" fill="#9266CC" />
      <path
        d="M163.354,283.961c-32.309-7.521-52.403-39.809-44.883-72.118c5.63-24.185,25.139-41.523,48.145-45.56 c-31.155-5.424-61.49,14.374-68.75,45.56c-7.521,32.309,12.574,64.597,44.883,72.118c8.124,1.891,16.246,2.033,23.974,0.677 C165.6,284.443,164.477,284.223,163.354,283.961z"
        fill="#7B54BA"
      />
      <circle cx="228.98" cy="284.596" r="60.06" fill="#AA8DD8" />
      <path
        d="M235.714,343.092c-32.309-7.521-52.404-39.809-44.883-72.118c5.63-24.185,25.138-41.523,48.144-45.56 c-31.155-5.424-61.49,14.374-68.749,45.56c-7.521,32.309,12.574,64.597,44.883,72.118c8.124,1.891,16.245,2.033,23.973,0.677 C237.96,343.574,236.837,343.354,235.714,343.092z"
        fill="#987FC9"
      />
      <circle cx="322.73" cy="324.056" r="60.06" fill="#AA8DD8" />
      <path
        d="M329.456,382.553c-32.309-7.521-52.404-39.809-44.883-72.118c5.63-24.185,25.138-41.523,48.144-45.56 c-31.155-5.424-61.49,14.374-68.749,45.56c-7.521,32.309,12.574,64.597,44.883,72.118c8.124,1.891,16.245,2.033,23.973,0.677 C331.702,383.035,330.58,382.815,329.456,382.553z"
        fill="#987FC9"
      />
    </svg>
  ),
  pineapple: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <path
          d="m302.977 120.231c6.891-49.174 24.551-80.753 35.512-96.295 2.491-3.532-1.098-8.175-5.135-6.63-40.94 15.667-65.903 41.9-81.103 67.122z"
          fill="#81b823"
        />
        <path
          d="m209.023 120.231c-6.891-49.174-24.551-80.753-35.512-96.295-2.491-3.532 1.098-8.175 5.135-6.63 40.94 15.667 65.903 41.9 81.103 67.122z"
          fill="#81b823"
        />
        <path
          d="m304.698 166.712-44.465-163.477c-1.173-4.314-7.292-4.314-8.466 0l-44.466 163.477z"
          fill="#97d729"
        />
        <path
          d="m304.698 166.712s-12.754-46.888-25.455-93.583c-8.875 9.418-16.004 18.949-21.652 27.775-.005.008-.011.017-.016.025-.738 1.153-2.413 1.153-3.151 0-.005-.008-.011-.017-.016-.025-5.648-8.826-12.776-18.357-21.652-27.775l-25.455 93.583z"
          fill="#8bc727"
        />
        <path
          d="m256 170.442s16.136-96.735 117.188-124.45c4.183-1.147 7.346 3.802 4.51 7.085-18.056 20.905-53.493 74.098-53.493 169.584h-68.205z"
          fill="#a2e62e"
        />
        <path
          d="m351.922 53.312c-18.114 21.06-53.294 74.202-53.294 169.349h25.577c0-95.477 35.43-148.668 53.488-169.578 2.828-3.274-.316-8.237-4.488-7.091-7.559 2.077-14.642 4.542-21.283 7.32z"
          fill="#97d729"
        />
        <path
          d="m256 170.442s-16.136-96.735-117.188-124.45c-4.183-1.147-7.346 3.802-4.51 7.085 18.056 20.905 53.493 74.098 53.493 169.584h68.205z"
          fill="#a2e62e"
        />
        <path
          d="m134.313 53.094c.062.072.125.145.188.218 82.094 34.338 95.922 117.13 95.922 117.13v52.219h25.577v-52.219s-16.136-96.737-117.191-124.451c-4.194-1.15-7.338 3.812-4.496 7.103z"
          fill="#97d729"
        />
        <path
          d="m410.527 349.699v-61.208l-5.287-8.231 5.197-7.285c-.738-20.99-6.532-40.69-16.204-57.925l-10.673-4.617 2.137-8.614c-17.055-23.171-41.732-40.38-70.338-47.928l-15.141 3.046-3.669-6.521c-4.569-.494-9.207-.755-13.907-.755h-53.285c-4.7 0-9.338.261-13.907.755l-3.669 6.521-15.141-3.046c-28.605 7.549-53.283 24.758-70.338 47.928l2.137 8.614-10.673 4.617c-9.673 17.234-15.467 36.935-16.204 57.925l5.197 7.285-5.287 8.231v61.208l5.287 5.738-5.287 19.181v9.498c0 28.818 9.535 55.407 25.617 76.791l7.403-1.011 7.597 17.69c7.857 7.339 16.635 13.703 26.149 18.889l9.051-2.229 5.279 8.923c14.491 5.7 30.274 8.831 46.788 8.831h53.285c16.514 0 32.297-3.131 46.788-8.831l5.279-8.923 9.051 2.229c9.514-5.186 18.292-11.551 26.149-18.889l7.597-17.69 7.403 1.011c16.083-21.384 25.617-47.973 25.617-76.791v-9.498l-5.287-19.181z"
          fill="#ffe177"
        />
        <path
          d="m410.527 349.699v-61.208l-5.287-8.231 5.197-7.285c-.738-20.99-6.532-40.69-16.204-57.925l-10.673-4.617 2.137-8.614c-17.055-23.171-41.732-40.38-70.338-47.928l-15.141 3.046-3.669-6.521c-4.569-.494-9.207-.755-13.907-.755h-31.971c70.629 0 127.884 57.256 127.884 127.884v106.57c.001 70.629-57.255 127.885-127.883 127.885h31.971c16.514 0 32.297-3.131 46.788-8.831l5.279-8.923 9.051 2.229c9.514-5.186 18.292-11.551 26.149-18.889l7.597-17.69 7.403 1.011c16.083-21.384 25.617-47.973 25.617-76.791v-9.498l-5.287-19.181z"
          fill="#ffd15b"
        />
      </g>
      <g fill="#fdb441">
        <path d="m410.527 349.699c-3.505-2.543-7.468-4.462-11.711-5.607l-13.906-3.762v-28.878c0-9.442 6.364-17.754 15.484-20.215l10.134-2.746v-10.946c0-1.53-.037-3.052-.09-4.57l-13.959 3.782c-7.777 2.099-14.386 6.681-19.068 12.749-4.681-6.067-11.288-10.651-19.062-12.752l-13.908-3.759v-28.456c0-9.438 6.364-17.75 15.475-20.213l34.318-9.275c-2.578-4.593-5.43-9.011-8.536-13.231l-29.696 8.026c-7.774 2.101-14.381 6.685-19.062 12.752-4.681-6.067-11.288-10.651-19.062-12.752l-13.908-3.759v-33.557c0-7.981 4.464-15.111 11.39-18.638-6.103-1.611-12.385-2.781-18.81-3.476-4.802 6.157-7.58 13.87-7.58 22.114v33.557l-13.908 3.759c-7.774 2.101-14.381 6.685-19.062 12.752-4.681-6.067-11.288-10.651-19.062-12.752l-13.908-3.759v-33.557c0-8.243-2.778-15.956-7.58-22.114-6.425.695-12.706 1.865-18.81 3.476 6.926 3.528 11.39 10.657 11.39 18.638v33.557l-13.909 3.759c-7.774 2.101-14.381 6.685-19.062 12.752-4.681-6.067-11.288-10.651-19.062-12.752l-29.695-8.026c-3.106 4.22-5.958 8.638-8.536 13.231l34.317 9.275c9.112 2.463 15.476 10.775 15.476 20.213v28.456l-13.908 3.759c-7.774 2.101-14.381 6.685-19.062 12.752-4.681-6.067-11.288-10.649-19.061-12.747l-13.966-3.784c-.053 1.517-.09 3.039-.09 4.57v10.947l10.141 2.748c9.112 2.458 15.476 10.77 15.476 20.212v28.878l-13.903 3.761c-4.245 1.146-8.209 3.066-11.715 5.609v24.918l2.65-5.765c2.724-5.045 7.442-8.787 12.978-10.281l17.489-4.731 17.493 4.732c9.112 2.459 15.477 10.771 15.477 20.213v28.456l-13.906 3.758c-15.639 4.227-26.562 18.494-26.562 34.694v15.213c4.506 5.992 9.53 11.571 15 16.68v-31.892c0-9.438 6.364-17.75 15.475-20.213l17.495-4.728 17.495 4.728c9.112 2.463 15.476 10.775 15.476 20.213v19.24l-13.901 3.761c-13.371 3.608-23.288 14.556-25.889 27.781 4.612 2.514 9.396 4.753 14.33 6.694.099-9.351 6.426-17.553 15.472-19.994l17.489-4.731 17.494 4.733c9.112 2.458 15.476 10.77 15.476 20.212v8.609h15v-8.611c0-9.442 6.364-17.754 15.481-20.214l17.489-4.731 17.494 4.733c9.04 2.439 15.368 10.642 15.467 19.992 4.934-1.941 9.718-4.18 14.33-6.694-2.601-13.224-12.518-24.173-25.885-27.779l-13.906-3.762v-19.24c0-9.438 6.364-17.75 15.475-20.213l17.495-4.728 17.494 4.728c9.112 2.463 15.476 10.775 15.476 20.213v31.892c5.47-5.109 10.494-10.688 15-16.68v-15.213c0-16.2-10.922-30.467-26.562-34.694l-13.908-3.759v-28.456c0-9.442 6.364-17.754 15.481-20.214l17.489-4.731 17.493 4.732c5.533 1.494 10.251 5.235 12.975 10.28l2.65 5.765v-24.917zm-147.027-105.16c0-9.438 6.364-17.75 15.475-20.213l17.495-4.728 17.495 4.728c9.112 2.463 15.476 10.775 15.476 20.213v28.456l-13.909 3.759c-7.774 2.101-14.381 6.685-19.061 12.752-4.681-6.067-11.287-10.651-19.061-12.752l-13.909-3.759v-28.456zm-7.5 41.967 17.495 4.729c9.111 2.463 15.475 10.774 15.475 20.213v28.884l-13.908 3.759c-7.774 2.101-14.381 6.684-19.062 12.752-4.681-6.067-11.288-10.651-19.062-12.752l-13.908-3.759v-28.884c0-9.438 6.364-17.75 15.475-20.213zm-73.44-41.967c0-9.438 6.364-17.75 15.475-20.213l17.495-4.728 17.494 4.728c9.112 2.463 15.476 10.775 15.476 20.213v28.456l-13.909 3.759c-7.774 2.101-14.38 6.685-19.061 12.752-4.681-6.067-11.287-10.651-19.062-12.752l-13.909-3.759v-28.456zm-7.499 112.303c-4.682-6.069-11.29-10.652-19.065-12.75l-13.906-3.762v-28.878-.004c0-9.438 6.364-17.75 15.476-20.213l17.494-4.729 17.495 4.729c9.112 2.463 15.476 10.775 15.476 20.213v28.884l-13.908 3.759c-7.775 2.101-14.381 6.684-19.062 12.751zm40.469 66.91c-4.681-6.067-11.288-10.651-19.062-12.752l-13.908-3.759v-28.456-.001c0-9.438 6.364-17.75 15.476-20.213l17.495-4.729 17.495 4.729c9.111 2.462 15.475 10.774 15.475 20.213v28.457l-13.91 3.759c-7.773 2.101-14.38 6.685-19.061 12.752zm73.44 41.182-13.901 3.761c-7.777 2.099-14.386 6.681-19.069 12.75-4.682-6.068-11.289-10.65-19.064-12.748l-13.906-3.762v-19.24c0-9.438 6.364-17.75 15.475-20.213l17.495-4.73 17.495 4.728c9.111 2.463 15.475 10.775 15.475 20.213zm40.47-86.148v28.456l-13.909 3.758c-7.774 2.101-14.381 6.685-19.062 12.752-4.681-6.067-11.287-10.651-19.062-12.752l-13.908-3.759v-28.457c0-9.438 6.364-17.75 15.476-20.213l17.494-4.729 17.495 4.729c9.112 2.463 15.476 10.775 15.476 20.215zm40.47-67.334v28.878l-13.901 3.761c-7.778 2.099-14.387 6.682-19.069 12.751-4.681-6.067-11.287-10.65-19.061-12.751l-13.909-3.759v-28.884c0-9.438 6.364-17.75 15.476-20.213l17.495-4.729 17.494 4.729c9.112 2.463 15.476 10.774 15.476 20.213v.004z" />
        <circle cx="256" cy="178.891" r="7.5" />
        <circle cx="215.53" cy="245.905" r="7.5" />
        <circle cx="134.59" cy="245.905" r="7.5" />
        <circle cx="175.06" cy="312.844" r="7.5" />
        <circle cx="134.59" cy="380.151" r="7.5" />
        <circle cx="215.53" cy="380.151" r="7.5" />
        <circle cx="256" cy="312.844" r="7.5" />
        <circle cx="175.06" cy="447.06" r="7.5" />
        <circle cx="256" cy="447.06" r="7.5" />
        <circle cx="336.94" cy="447.06" r="7.5" />
        <circle cx="296.47" cy="380.151" r="7.5" />
        <circle cx="377.41" cy="380.151" r="7.5" />
        <circle cx="336.94" cy="312.844" r="7.5" />
        <circle cx="377.41" cy="245.905" r="7.5" />
        <circle cx="296.47" cy="245.905" r="7.5" />
      </g>
    </svg>
  ),
  pear: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M412.448,366.471c0,90.985-74.082,146.164-165.215,145.524c-4.217-0.034-8.389-0.183-12.526-0.446 h-0.011c-84.813-5.532-151.524-60.996-150.301-147.444c0.64-44.778,19.223-85.191,48.87-114.414 c12.8-12.606,20.972-29.064,23.418-46.87c0.08-0.526,0.149-0.994,0.229-1.406c8.709-45.475,46.367-79.682,91.499-79.682h0.48 c44.915,0.24,82.345,34.367,91.019,79.682c0.046,0.206,0.08,0.423,0.114,0.663c2.949,18.389,11.395,35.429,24.549,48.618 C394.15,280.354,412.448,321.271,412.448,366.471z"
        fill="#A3E261"
      />
      <path
        d="M248.89,121.733l-1.143,34.801c0,0-15.629,11.835-17.372,41.167 c-4.572,76.954-64.573,104.383-64.573,182.099s28.001,108.194,68.916,131.737l-0.011,0.011h-0.011 c-84.814-5.532-151.524-60.996-150.301-147.444c0.64-44.778,19.223-85.191,48.87-114.414c12.8-12.606,20.972-29.064,23.418-46.87 c0.08-0.526,0.149-0.994,0.229-1.406c8.709-45.475,46.367-79.682,91.499-79.682L248.89,121.733L248.89,121.733z"
        fill="#93CC52"
      />
      <path
        d="M246.627,154.299c-0.495,0-0.995-0.043-1.498-0.131c-4.661-0.822-7.773-5.265-6.953-9.926l0,0 c0.136-0.778,13.257-78.168-19.014-110.439c-3.348-3.348-3.348-8.775,0-12.121c3.348-3.348,8.775-3.348,12.121,0 c38.585,38.585,24.399,122.002,23.777,125.533C254.325,151.373,250.708,154.299,246.627,154.299z"
        fill="#B25719"
      />
      <path
        d="M228.496,141.119c5.048-0.051,8.389-0.114,11.401-0.314c2.96-0.17,5.391-0.28,7.845-0.283 c2.453-0.017,4.88,0.095,7.834,0.262c3.009,0.199,6.348,0.271,11.411,0.337c0.015,5.097-2.673,9.214-6.25,12.135 c-3.626,2.896-8.321,4.42-12.995,4.407c-4.673-0.008-9.364-1.53-12.985-4.43C231.184,150.309,228.497,146.201,228.496,141.119z"
        fill="#93CC52"
      />
      <path
        d="M276.431,69.153c-30.046,0-43.912-20.309-44.6-21.349c-1.917-2.895-1.125-6.794,1.769-8.712 c2.885-1.91,6.768-1.129,8.692,1.741c0.693,1.014,16.202,22.948,51.618,13.223c3.348-0.922,6.807,1.049,7.726,4.398 c0.919,3.348-1.049,6.807-4.398,7.726C289.589,68.279,282.661,69.153,276.431,69.153z"
        fill="#B25719"
      />
      <path
        d="M384.905,76.859l42.718-45.119L371.103,5.929c-34.697-15.846-75.534,1.263-88.576,37.108 l-1.178,3.239c-3.354,9.221-1.347,19.541,5.221,26.832l2.307,2.561C314.406,104.009,358.68,104.558,384.905,76.859z"
        fill="#2FCC6E"
      />
    </svg>
  ),
  mango: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m427.346 155.544c-10.277-42.554-36.409-101.264-124.82-126.736-102.758-29.607-184.332 64.679-203.605 103.894s-61.827 106.102-74.28 118.927-45.459 81.045 35.123 114.764c80.454 33.665 162.997 27.239 266.701-27.975s108.966-149.4 100.881-182.874z"
        fill="#f25226"
      />
      <path
        d="m369.188 309.179c-36.768-61.846-111.317-120.937-157.31-180.141-26.221-33.753-28.642-63.263-21.962-86.636-46.438 24.702-79.603 67.12-90.995 90.3-19.272 39.215-61.827 106.102-74.28 118.927-12.452 12.825-45.459 81.046 35.123 114.764 80.454 33.665 162.997 27.239 266.701-27.975 16.672-8.876 30.786-18.763 42.723-29.239z"
        fill="#f27126"
      />
      <path
        d="m86.802 155.657c-21.268 38.231-51.911 85.415-62.161 95.972-12.452 12.825-45.459 81.046 35.123 114.764 40.692 17.027 81.924 23.779 126.153 19.169-68.77-74.034-92.205-163.027-99.115-229.905z"
        fill="#f29018"
      />
      <path
        d="m389.402 288.579c-241.571 112.988-338.328 2.362-363.942-37.827-.284.312-.56.61-.819.876-12.452 12.825-45.459 81.045 35.123 114.764 80.454 33.665 162.997 27.239 266.701-27.975 27.275-14.52 47.733-31.739 62.937-49.838z"
        fill="#9e441a"
        opacity={0.17}
      />
      <path
        d="m275.633 237.445-224.587 162.726 8.88 22.752c52.098 35.652 123.055 36.76 177.108-2.404s75.102-106.937 57.453-167.548z"
        fill="#f25226"
      />
      <path
        d="m262.296 247.111-198.54 143.853 8.894 21.555c46.207 29.824 107.864 30.026 155.077-4.182s66.227-92.861 52.28-146.059z"
        fill="#ffcb2e"
      />
      <g>
        <path
          d="m389.855 181.553c37.71 61.897 112.447 85.53 112.447 85.53s13.599-76.721-24.111-138.618-93.558-54.524-93.558-54.524-32.488 45.715 5.222 107.612z"
          fill="#57a633"
        />
      </g>
      <g>
        <path
          d="m502.303 267.091s13.592-76.737-24.112-138.62c-37.704-61.898-93.564-54.539-93.564-54.539z"
          fill="#407a26"
        />
      </g>
      <path
        d="m232.005 424.013c-105.634 3.552-147.868-21.376-163.604-36.418l-17.356 12.575 8.88 22.752c50.498 34.557 118.713 36.659 172.08 1.091z"
        fill="#9e441a"
        opacity={0.17}
      />
      <path
        d="m340.768 485.689c79.927-16.893 131.026-95.381 114.134-175.307l-289.442 61.174c16.893 79.927 95.381 131.026 175.308 114.133z"
        fill="#f25226"
      />
      <path
        d="m338.017 469.557c71.086-15.024 116.533-84.83 101.509-155.916l-257.425 54.407c15.024 71.086 84.83 116.534 155.916 101.509z"
        fill="#ffcb2e"
      />
      <path
        d="m171.313 391.938c24.862 68 96.555 109.159 169.454 93.752 28.232-5.967 52.86-19.626 72.173-38.312-119.698 42.552-206.428-21.596-241.627-55.44z"
        fill="#9e441a"
        opacity={0.17}
      />
      <path d="m499.397 156.318c-1.358-3.789-5.53-5.759-9.316-4.403-3.788 1.357-5.759 5.527-4.404 9.316 13.981 39.046 12.234 78.708 10.532 95.829-20.039-8.052-71.599-32.425-100.154-79.296-19.364-31.786-23.262-67.871-7.203-96.785 4.932-.117 14.912.295 26.884 4.179 22.757 7.382 41.669 23.229 56.211 47.099 2.096 3.437 6.578 4.527 10.013 2.431 3.436-2.093 4.524-6.576 2.431-10.012-20.655-33.904-46.72-47.878-64.949-53.631-9.449-2.982-17.816-4.13-24.083-4.503.814-.787 1.508-1.473 2.013-1.995 3.348-3.461 3.257-8.982-.204-12.331-3.463-3.349-8.982-3.258-12.332.204-1.15 1.189-3.985 3.876-6.974 6.664-19.866-16.435-44.405-28.939-73.342-37.276-74.638-21.506-142.161 18.867-185.405 68.918-2.631 3.045-2.294 7.646.751 10.276 3.043 2.631 7.645 2.295 10.276-.751 23.607-27.332 87.467-88.325 170.345-64.442 26.556 7.651 48.762 18.769 66.815 33.464-2.836 4.603-.443 11.145 4.86 12.77-11.564 29.804-13.782 61.886 11.449 103.3 9.238 15.164 20.528 28.082 32.404 38.982-13.407 45.252-43.824 80.427-89.44 105.727l-23.594 4.987c6.807-27.12 6.632-56.109-1.521-84.106-.41-1.406-1.233-2.656-2.364-3.587l-18.854-15.526c-2.559-2.107-6.22-2.221-8.906-.276l-66.162 47.938c-3.259 2.361-3.986 6.916-1.625 10.175 2.36 3.259 6.918 3.986 10.175 1.625l61.602-44.635 12.748 10.499c7.475 27.203 6.732 55.349-1.139 81.283l-123.004 25.997c-3.881.799-6.44 4.762-5.622 8.635 5.058 23.931 15.41 45.41 29.572 63.471-40.68 11.847-85.509 5.795-122.019-18.382l-6.004-15.384 126.494-91.652c3.259-2.361 3.986-6.916 1.625-10.175s-6.918-3.986-10.175-1.625l-94.143 68.212c-31.115-9.915-62.217-27.706-67.957-55.745-5.163-25.221 8.763-49.536 14.144-55.078 12.975-13.364 55.78-80.479 75.591-120.789 1.774-3.611.286-7.978-3.326-9.752-3.61-1.775-7.976-.287-9.752 3.325-18.936 38.531-60.909 104.646-72.967 117.065-8.257 8.504-24.245 37.472-17.965 68.151 6.44 31.46 32.721 50.595 67.856 63.239l-22.533 16.329c-2.686 1.946-3.718 5.46-2.512 8.549l8.88 22.751c.532 1.365 1.464 2.537 2.672 3.364 42.213 28.893 94.946 35.607 142.55 19.605 36.339 37.758 91.297 55.398 143.913 44.278 41.665-8.806 77.031-33.557 99.582-69.693 2.131-3.413 1.09-7.908-2.323-10.038-3.412-2.132-7.907-1.091-10.038 2.323-20.435 32.744-52.482 55.172-90.234 63.151-73.479 15.531-145.926-29.639-164.984-101.423l274.82-58.083c3.811 24.071 1.335 48.609-7.262 71.408-1.42 3.765.482 7.969 4.246 9.388 3.767 1.421 7.968-.481 9.388-4.246 10.435-27.675 12.704-57.665 6.561-86.73-.818-3.871-4.77-6.46-8.635-5.622l-88.203 18.642c29.902-23.637 51.399-53.101 62.896-87.308 34.535 27.31 69.866 38.762 72.018 39.442 1.992.63 4.173.375 5.971-.715 1.794-1.087 3.033-2.894 3.399-4.961.406-2.291 9.724-56.784-10.058-112.035z" />
    </svg>
  ),
  peach: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <ellipse cx="220.817" cy="264.372" fill="#f24e30" rx="135.299" ry="160.827" />
      </g>
      <g opacity={0.15}>
        <path d="m278.681 389.247c-74.723 0-135.299-72.005-135.299-160.827 0-47.911 17.631-90.92 45.594-120.384-59.357 17.022-103.458 80.552-103.458 156.335 0 88.822 60.575 160.827 135.299 160.827 34.417 0 65.827-15.284 89.704-40.443-10.211 2.929-20.871 4.492-31.84 4.492z" />
      </g>
      <g>
        <g>
          <g>
            <path
              d="m179.527 46.878c-25.337-31.73-77.486-32.212-77.486-32.212s-11.068 50.963 14.269 82.693 64.794 16.318 64.794 16.318 23.761-35.068-1.577-66.799z"
              fill="#57a633"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="m102.041 14.661s-11.064 50.971 14.269 82.693c25.333 31.732 64.798 16.326 64.798 16.326z"
              fill="#407a26"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="m192.197 132.161c-.415 0-.834-.02-1.255-.063-6.855-.686-11.864-6.773-11.197-13.63.213-2.191 5.687-53.997 45.919-83.343 5.576-4.07 13.395-2.845 17.462 2.732 4.068 5.577 2.845 13.395-2.732 17.462-31.025 22.631-35.73 65.177-35.774 65.604-.661 6.432-6.091 11.238-12.423 11.238z"
          fill="#59330c"
        />
      </g>
      <g>
        <ellipse cx="135.299" cy="264.372" fill="#ff7133" rx="135.299" ry="160.827" />
      </g>
      <g opacity={0.15}>
        <path d="m266.669 225.792c-36.432 14.188-68.531 49.369-82.833 96.296-7.005 22.986-8.864 46.001-6.341 67.287-72.78-2.638-131.1-73.59-131.1-160.742 0-44.716 15.357-85.163 40.138-114.313-50.624 23.263-86.533 81.669-86.533 150.052 0 88.822 60.575 160.827 135.299 160.827 31.495 0 60.112-12.721 82.833-33.668 43.493-40.097 61.011-105.03 48.537-165.739z" />
      </g>
      <g>
        <path
          d="m453.216 229.961c-11.327-5.26-23.302-7.996-35.477-8.447-8.2-9.011-18.017-16.394-29.344-21.654-56.638-26.301-129.461 10.325-162.655 81.807-33.194 71.481-14.188 150.75 42.45 177.051 11.327 5.26 23.302 7.996 35.477 8.447 8.2 9.011 18.017 16.394 29.344 21.654 56.638 26.301 129.461-10.325 162.655-81.807s14.189-150.75-42.45-177.051z"
          fill="#f24e30"
        />
      </g>
      <g>
        <path
          d="m311.599 450.086c-86.794 1.856-99.546-97.73-70.113-161.108 32.448-69.869 118.838-112.445 168.323-50.385 80.184.077 101.078 94.418 70.112 161.108-33.11 71.303-117.819 111.534-168.322 50.385z"
          fill="#ffd230"
        />
      </g>
      <g>
        <path
          d="m410.956 365.831c-18.726 40.28-83.414 49.918-83.414 49.918s-34.328-55.669-15.602-95.95c18.726-40.28 83.414-49.918 83.414-49.918s34.328 55.669 15.602 95.95z"
          fill="#ab280f"
        />
      </g>
    </svg>
  ),
  watermelon: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m8 418.897c.001.001.002.002.003.003 113.466 113.466 297.431 113.466 410.897 0s113.466-297.431 0-410.897c-.001-.001-.002-.002-.003-.003z"
        fill="#98db7c"
      />
      <path
        d="m418.9 391.9c-108.93 108.93-282.822 113.265-396.947 13.045l-13.953 13.952c.001.001.002.002.003.003 113.466 113.466 297.431 113.466 410.897 0 60.168-60.168 88.425-140.158 84.783-218.949-3.226 69.797-31.484 138.651-84.783 191.949z"
        fill="#82d361"
      />
      <path
        d="m41.638 385.26c.001.001.002.002.003.003 94.889 94.888 248.734 94.889 343.622 0 94.889-94.888 94.888-248.733 0-343.622-.001-.001-.002-.002-.003-.003z"
        fill="#ff4755"
      />
      <path
        d="m385.263 358.263c-90.346 90.346-234.136 94.667-329.599 12.971l-14.026 14.026c.001.001.002.002.003.003 94.889 94.888 248.734 94.888 343.622 0 50.879-50.879 74.462-118.708 70.778-185.311-3.186 57.61-26.769 114.301-70.778 158.311z"
        fill="#fc2b3a"
      />
      <path d="m502.799 139.62c-13.163-51.861-40.226-99.379-78.267-137.42-2.934-2.934-7.693-2.934-10.627 0l-133.885 133.885c-2.935 2.935-2.935 7.693 0 10.628 2.934 2.933 7.693 2.933 10.627 0l94.775-94.775c41.248 43.894 63.886 100.92 63.886 161.431 0 63.022-24.542 122.271-69.105 166.833-54.982 54.983-133.518 79.326-210.074 65.133-4.026-.742-8.012 1.992-8.759 6.019-.747 4.026 1.992 8.012 6.018 8.758 15.293 2.837 30.651 4.226 45.912 4.226 65.999 0 130.029-26.009 177.529-73.508 47.402-47.401 73.507-110.425 73.507-177.461 0-64.526-24.197-125.327-68.282-172.065l23.092-23.092c33.373 35.18 57.199 78.282 69.083 125.106 12.14 47.83 11.619 98.244-1.507 145.793-1.061 3.842 1.172 7.961 4.974 9.164 4.009 1.268 8.395-1.112 9.513-5.164 13.822-50.061 14.371-103.137 1.59-153.491z" />
      <path d="m487.221 312.628c-3.865-1.513-8.224.395-9.737 4.259-14.267 36.458-35.657 69.1-63.576 97.018-53.566 53.567-124.784 83.066-200.537 83.066-73.242 0-142.248-27.578-195.158-77.823l23.087-23.088c27.35 25.751 60.384 45.224 95.975 56.514 4.065 1.294 8.486-1.177 9.551-5.296.985-3.81-1.259-7.841-5.006-9.029-33.811-10.726-64.014-28.484-89.888-52.821l217.46-217.46c2.935-2.936 2.935-7.693 0-10.628-2.935-2.934-7.693-2.934-10.627 0l-256.562 256.562c-2.935 2.935-2.932 7.696.003 10.631 56.404 56.404 131.397 87.467 211.164 87.467s154.76-31.063 211.165-87.467c29.394-29.393 51.917-63.768 66.945-102.168 1.512-3.865-.395-8.224-4.259-9.737z" />
      <path d="m301.232 315.516c3.816 0 7.403-1.486 10.101-4.184 2.699-2.698 4.185-6.286 4.185-10.102s-1.486-7.403-4.184-10.102c0-.001-.001-.001-.001-.002-2.032-2.031-17.381-13.61-25.597-5.392-2.467 2.468-4.619 7.214-.857 15.811 1.646 3.761 4.159 7.694 6.251 9.786 2.697 2.698 6.285 4.185 10.102 4.185z" />
      <path d="m226.908 320.734c-11.498 1.697-11.356 20.918-10.937 23.763 1.045 7.091 7.16 12.206 14.126 12.206 5.939 0 11.369-3.806 13.42-9.373 2.226-6.042-.384-12.568-3.405-17.852-4.657-8.147-9.75-9.247-13.204-8.744z" />
      <path d="m138.187 342.203c-1.335 3.574-1.197 7.456.387 10.927 2.379 5.212 7.803 8.568 13.539 8.351 5.711-.217 10.848-3.942 12.842-9.287 1.036-2.774 1.688-7.394 1.624-11.498-.147-9.384-4.076-12.809-7.345-14.028-10.89-4.066-20.043 12.844-21.047 15.535z" />
      <path d="m320.736 226.908c-1.694 11.499 16.755 16.909 19.596 17.328 7.712 1.131 15.082-4.347 16.218-12.051 1.136-7.709-4.353-15.083-12.051-16.216-2.846-.416-22.067-.56-23.763 10.939z" />
      <path d="m340.697 166.576c3.802.06 7.909-.283 11.498-1.623 7.288-2.719 11.117-11.076 8.389-18.379-2.72-7.288-11.074-11.115-18.379-8.39-2.774 1.035-6.693 3.57-9.751 6.308-6.993 6.259-7.006 11.471-5.785 14.741 1.221 3.269 4.645 7.196 14.028 7.343z" />
    </svg>
  ),
  kiwi: (props) => (
    <svg viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m49.9741 64.214c.1083-30.6338 8.6105-45.9318 34.4372-45.9034h1.9772c26.0449-.0392 34.4843 15.4937 34.4647 46.6086 0 .29 0 .58-.01.87.01.29.01.58.01.87.02 31.5-8.63 47.03-35.44 46.6-12.1559.195-20.5785-2.8911-26.1523-9.2592z"
        fill="#ad7753"
      />
      <path
        d="m120.8533 64.9193c.016-25.4364-5.6275-40.4532-21.9148-45.0679 2.4425 7.2547 3.2914 16.4981 2.9638 27.7648-.0081.29-.0163.58-.0346.8693.0017.29-.0065.58-.0147.87-.8755 31.4878-9.9631 46.7657-36.75 45.5739a55.0335 55.0335 0 0 1 -8.1143-.6646l2.272 9.7352c5.5739 6.3681 13.9965 9.4542 26.1524 9.2592 26.81.43 35.46-15.1 35.44-46.6 0-.29 0-.58-.01-.87.0102-.2899.0102-.5799.0102-.8699z"
        fill="#96674d"
      />
      <circle cx="44" cy="77.268" fill="#bf8166" r="36" />
      <circle cx="44" cy="77.268" fill="#97c655" r="34" />
      <circle cx="44" cy="77.268" fill="#b1d873" r="17.747" />
      <path
        d="m66.6252 51.9169a33.9771 33.9771 0 0 1 -47.9768 47.9753 33.9805 33.9805 0 1 0 47.9768-47.9753z"
        fill="#87aa4f"
      />
      <circle cx="44" cy="77.268" fill="#ddf49d" r="10.855" />
      <g fill="#363f25">
        <path d="m44 62.5254a1 1 0 0 1 -1-1v-4.6567a1 1 0 1 1 2 0v4.6567a1 1 0 0 1 -1 1z" />
        <path d="m39.5254 61.6064a1.0007 1.0007 0 0 1 -.9649-.7417l-.582-2.17a1 1 0 1 1 1.9317-.5175l.582 2.17a1.0017 1.0017 0 0 1 -.9668 1.2592z" />
        <path d="m36.13 64.6343a1 1 0 0 1 -.8672-.5l-2.3281-4.0327a1 1 0 1 1 1.7324-1l2.3281 4.0327a1 1 0 0 1 -.8652 1.5z" />
        <path d="m31.7939 66.0752a.9969.9969 0 0 1 -.707-.293l-1.5879-1.5888a1 1 0 1 1 1.4141-1.4141l1.5879 1.5889a1 1 0 0 1 -.7071 1.707z" />
        <path d="m30.3652 70.3965a.9946.9946 0 0 1 -.499-.1338l-4.0322-2.3281a1 1 0 0 1 1-1.7325l4.0322 2.3279a1 1 0 0 1 -.501 1.8662z" />
        <path d="m27.334 73.8115a.9916.9916 0 0 1 -.26-.0342l-2.17-.581a1 1 0 0 1 .5176-1.9317l2.17.5811a1 1 0 0 1 -.2578 1.9658z" />
        <path d="m28.2578 78.2676h-4.6572a1 1 0 0 1 0-2h4.6572a1 1 0 1 1 0 2z" />
        <path d="m25.167 83.3232a1 1 0 0 1 -.2578-1.9658l2.17-.581a1 1 0 0 1 .5176 1.9316l-2.17.5811a.9967.9967 0 0 1 -.2598.0341z" />
        <path d="m26.335 88.4678a1 1 0 0 1 -.501-1.8662l4.0322-2.3282a1 1 0 0 1 1 1.7325l-4.0322 2.3281a.9946.9946 0 0 1 -.499.1338z" />
        <path d="m30.2188 92.0625a1 1 0 0 1 -.7071-1.707l1.5889-1.5889a1 1 0 1 1 1.414 1.4141l-1.5888 1.5893a.9969.9969 0 0 1 -.707.2925z" />
        <path d="m33.8 95.9346a1 1 0 0 1 -.8652-1.5l2.3281-4.0332a1 1 0 1 1 1.7324 1l-2.3283 4.0332a1.0012 1.0012 0 0 1 -.867.5z" />
        <path d="m38.9629 97.1045a1 1 0 0 1 -.9668-1.2588l.582-2.17a1 1 0 0 1 1.9317.5176l-.5821 2.17a1 1 0 0 1 -.9648.7412z" />
        <path d="m44 98.667a1 1 0 0 1 -1-1v-4.6563a1 1 0 1 1 2 0v4.6563a1 1 0 0 1 -1 1z" />
        <path d="m49.0547 97.1006a1 1 0 0 1 -.9649-.7412l-.582-2.1709a1 1 0 0 1 1.9317-.5176l.582 2.1709a1 1 0 0 1 -.9668 1.2588z" />
        <path d="m54.2 95.9346a.9991.9991 0 0 1 -.8672-.5l-2.3281-4.0332a1 1 0 0 1 1.7324-1l2.3281 4.0332a1 1 0 0 1 -.8652 1.5z" />
        <path d="m57.7939 92.05a.9969.9969 0 0 1 -.707-.293l-1.5879-1.589a1 1 0 1 1 1.4141-1.4141l1.5879 1.5889a1 1 0 0 1 -.7071 1.707z" />
        <path d="m61.665 88.4678a.9946.9946 0 0 1 -.499-.1338l-4.0322-2.3281a1 1 0 0 1 1-1.7325l4.0322 2.3282a1 1 0 0 1 -.501 1.8662z" />
        <path d="m62.8379 83.3057a.9964.9964 0 0 1 -.26-.0342l-2.17-.5811a1 1 0 1 1 .5176-1.9316l2.17.581a1 1 0 0 1 -.2578 1.9659z" />
        <path d="m64.3994 78.2676h-4.6572a1 1 0 1 1 0-2h4.6572a1 1 0 0 1 0 2z" />
        <path d="m60.6611 73.7939a1 1 0 0 1 -.2578-1.9658l2.17-.582a1 1 0 1 1 .5176 1.9316l-2.17.5821a.9956.9956 0 0 1 -.2598.0341z" />
        <path d="m57.6348 70.3965a1 1 0 0 1 -.501-1.8662l4.0322-2.3282a1 1 0 0 1 1 1.7325l-4.0322 2.3281a.9946.9946 0 0 1 -.499.1338z" />
        <path d="m56.1924 66.0625a1 1 0 0 1 -.707-1.707l1.5888-1.5889a1 1 0 0 1 1.4141 1.4141l-1.5889 1.5893a.9969.9969 0 0 1 -.707.2925z" />
        <path d="m51.87 64.6343a1 1 0 0 1 -.8652-1.5l2.3281-4.0327a1 1 0 1 1 1.7324 1l-2.3281 4.0327a1 1 0 0 1 -.8672.5z" />
        <path d="m48.457 61.6016a1.0021 1.0021 0 0 1 -.9668-1.2593l.5821-2.17a1 1 0 1 1 1.9316.5176l-.582 2.17a1.0008 1.0008 0 0 1 -.9649.7417z" />
      </g>
      <path d="m89.0141 20.0492a22.8245 22.8245 0 0 1 -7.202 0l.826-4.5h5.55z" fill="#7f523b" />
      <path
        d="m88.1882 15.5494h-2.3217l.1743.9494a1.8537 1.8537 0 0 1 -1.6767 2.1872 23.0149 23.0149 0 0 1 -2.3094.0414l-.2426 1.3219a22.8311 22.8311 0 0 0 7.2021 0z"
        fill="#6d4432"
      />
    </svg>
  ),
  abricot: (props) => (
    <svg
      height="512"
      viewBox="0 0 450 450"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipRule="evenodd" fillRule="evenodd">
        <path
          d="m72.433 341.981c-16.788 4.133-47.58-5.394-34.116-23.621 4.884-64.433 119.901-49.78 130.74-18.699 9.54 27.372-64.332 52.032-96.624 42.32"
          fill="#5fbd2f"
        ></path>
        <path
          d="m132.63 311.353c-9.703 3.436-16.617 20.884-9.089 26.682-27.784 61.291 6.994 46.48 13.241 53.084 7.307 7.722 30.452 7.758 39.521 1.893 18.087 1.944 16.179 4.039 27.945-7.663 17.036-.968 21.748-4.07 31.176-18.927-14.491-23.591-39.917-52.505-41.198-80.279-15.806-2.238-59.175 8.02-61.596 25.21"
          fill="#70cc42"
        ></path>
        <path
          d="m183.938 298.256c-70.766 35.484-127.952-36.102-134.117-101.882-5.697-60.778 27.855-122.358 96.627-126.796 69.713-4.497 119.629 38.755 119.629 110.919-27.38 39.252-54.758 78.507-82.139 117.759"
          fill="#f90"
        ></path>
        <path
          d="m183.938 298.256c-76.361 38.29-134.903-46.666-134.732-115.509 40.707 107.809 120.698 103.09 160.593 78.436z"
          fill="#f08b08"
        ></path>
        <path
          d="m192.384 229.241c31.779-68.222 119.487-88.933 173.499-54.893 22.368 14.095 33.111 42.398 36.351 70.708 2.202 19.245 10.934 33.515 12.452 46.349 5.13 43.291-54.711 82.722-90.641 91.847-102.681 26.074-173.942-64.295-131.661-154.011"
          fill="#ffb13d"
        ></path>
        <path
          d="m402.234 245.057c2.208 19.329 13.978 37.137 12.663 55.344-3.232-26.561-11.03-44.803-51.208-43.47-2.474-7.061-4.954-14.118-7.428-21.179 11.444-21.218 11.487-50.873-6.954-68.557-.137-.132 45.059 9.056 52.927 77.862"
          fill="#f90"
        ></path>
        <path
          d="m359.976 246.341c-16.068 92.007-121.225 95.346-132.034 56.741-17.19-61.352 82.085-103.314 132.034-56.741"
          fill="#c56640"
        ></path>
        <path
          d="m147.245 103.413c19.866-15.814 33.723-22.716 55.465-30.651 0 3.186 4.376 14.488 4.376 17.672-22.272 7.74-34.816 18.205-40.244 25.376-3.372-5.522-12.896-12.818-19.597-12.397"
          fill="#a66b41"
        ></path>
        <path
          d="m130.302 161.82c-4.284 17.802-20.222 29.299-35.603 25.681-15.38-3.615-24.376-20.976-20.092-38.775 4.283-17.802 20.222-29.299 35.602-25.683 15.381 3.619 24.376 20.979 20.093 38.777"
          fill="#ffb13d"
        ></path>
        <path
          d="m357.496 92.566c4.712 4.107 10.311 5.33 13.956 7.18 30.783 15.684-11.543 9.484-14.166 10.704-77.026 35.746-197.356-17.43-145.005-47.364 27.108-15.5 89.679-18.942 145.215 29.48"
          fill="#70cc42"
        ></path>
      </g>
    </svg>
  ),
  cherries: (props) => (
    <svg height="512" viewBox="0 0 70 70" width="512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <g>
          <path
            d="m24.482 44.446c-.104 0-.209-.016-.313-.051-.524-.173-.809-.738-.636-1.263 7.684-23.279.753-30.146.683-30.212-.403-.378-.422-1.011-.044-1.413.378-.403 1.012-.422 1.413-.044.328.308 7.927 7.817-.152 32.296-.14.421-.531.687-.951.687z"
            fill="#6c6"
          ></path>
        </g>
        <g>
          <path
            d="m47.347 46.139c-.406 0-.787-.248-.937-.651-8.477-22.768-18.265-24-18.363-24.01-.545-.055-.95-.539-.901-1.085s.526-.941 1.07-.908c.448.036 11.074 1.147 20.068 25.306.193.518-.07 1.093-.588 1.286-.115.041-.233.062-.349.062z"
            fill="#6c6"
          ></path>
        </g>
        <g>
          <g>
            <path
              d="m39.274 53.972c-1.312 8.005-8.826 13.772-16.896 12.952-8.885-.904-15.129-9.017-13.826-17.762.984-6.611 6.001-11.626 12.181-12.927 1.787-.376 3.601.526 4.375 2.18.276.589 1.063.707 1.499.225l.014-.016c1.097-1.211 3.215-1.653 4.656-.882 5.688 3.047 9.104 9.472 7.997 16.23z"
              fill="#fd4f5a"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m28.476 66.292c-1.93.61-4 .84-6.1.63-8.88-.9-15.13-9.02-13.82-17.76.98-6.61 6-11.63 12.18-12.93 1.7-.35 3.43.45 4.25 1.95-3.78 2.32-6.56 6.24-7.27 10.98-1.14 7.69 3.55 14.91 10.76 17.13z"
              fill="#ef3c4e"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m41.975 17.394c-3.06 3.06-7.927 4.314-13.873 3.036l-.013-.003.002-.017c-2.555-11.893 5.017-19.465 16.915-16.914l.008.008c1.285 5.954.026 10.825-3.039 13.89z"
              fill="#6c6"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m31.796 20.912c-1.17-.04-2.4-.2-3.69-.48h-.02l.01-.02c-2.56-11.89 5.01-19.47 16.91-16.92l.01.01c.19.87.32 1.72.4 2.55-8.93-.37-14.54 5.65-13.62 14.86z"
              fill="#53bc53"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m31.047 51.486c2.094 7.836 10.141 12.835 18.09 11.223 8.753-1.775 14.166-10.464 12.008-19.038-1.631-6.481-7.118-10.978-13.395-11.663-1.815-.198-3.531.879-4.139 2.601-.216.613-.988.808-1.47.372l-.015-.014c-1.211-1.097-3.362-1.328-4.72-.419-5.36 3.591-8.127 10.322-6.359 16.938z"
              fill="#fd4f5a"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m52.286 33.222c-.36.39-.65.86-.84 1.39-.14.39-.5.6-.86.6-.22 0-.43-.07-.61-.23l-.02-.02c-1.21-1.09-3.36-1.32-4.72-.41-5.36 3.59-8.12 10.32-6.36 16.93 1.47 5.52 5.9 9.63 11.17 11.01-.3.09-.6.16-.91.22-7.95 1.61-15.99-3.39-18.09-11.23-1.77-6.61 1-13.34 6.36-16.93 1.36-.91 3.51-.68 4.72.41l.02.02c.18.16.39.23.61.23.36 0 .72-.21.86-.6.6-1.73 2.32-2.8 4.13-2.6 1.58.17 3.11.59 4.54 1.21z"
              fill="#ef3c4e"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  coconut: (props) => (
    <svg
      height="511pt"
      viewBox="0 -23 511.99987 511"
      width="511pt"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m435.980469 13.535156c43.839843 37.160156 14.296875 139.519532-63.445313 229.902344-31.515625 36.640625-66.453125 65.511719-99.78125 84.425781 9.578125 23.53125 15.875 46.503907 14.113282 64.355469 63.980468 2.402344 128.40625-23.214844 173.207031-75.300781 77.742187-90.378907 66.957031-226.210938-24.09375-303.382813zm0 0"
        fill="#9e6b57"
      ></path>
      <path
        d="m314.242188 344.222656c-3.023438-11.457031-7.234376-23.226562-12.5-35.089844-9.714844 7.019532-19.417969 13.296876-28.988282 18.730469 9.578125 23.53125 15.875 46.503907 14.113282 64.355469 10.945312.410156 21.90625-.019531 32.777343-1.238281.816407-14.210938-.953125-29.910157-5.402343-46.757813zm0 0"
        fill="#875848"
      ></path>
      <path
        d="m435.980469 13.535156c-43.839844-37.15625-142.402344 8.046875-220.144531 98.429688-22.941407 26.671875-36.675782 57.710937-50.324219 84.609375 21.445312 14.175781 38.457031 28.082031 58.492187 51.375 22.925782 26.65625 40.164063 54.78125 50.8125 80.945312 33.324219-18.914062 68.261719-47.789062 99.78125-84.425781 77.738282-90.382812 105.222656-193.773438 61.382813-230.933594zm0 0"
        fill="#875848"
      ></path>
      <path
        d="m302.582031 311.039062c-12.183593-28.03125-30.347656-56.675781-52.960937-83.160156-21.109375-24.71875-44.683594-45.902344-68.695313-61.976562-5.441406 10.5-10.4375 20.859375-15.414062 30.671875 21.445312 14.175781 38.457031 28.082031 58.492187 51.375 22.925782 26.65625 40.164063 54.78125 50.8125 80.941406 9.167969-5.199219 18.460938-11.183594 27.765625-17.851563zm0 0"
        fill="#7a4c40"
      ></path>
      <path
        d="m413.207031 23.503906c-39.304687-33.3125-127.671875 5.367188-197.371093 86.402344-23.203126 26.972656-41.40625 55.238281-53.925782 82.175781 21.050782 14.097657 42.4375 33.019531 62.089844 55.867188 16.980469 19.738281 30.835938 40.285156 41.210938 60.242187 30.925781-16.890625 63.597656-43.507812 92.960937-77.644531 69.703125-81.03125 94.34375-173.726563 55.035156-207.042969zm0 0"
        fill="#e4eaf8"
      ></path>
      <path
        d="m292.804688 290.8125c-11.378907-21.414062-25.992188-42.796875-43.183594-62.933594-22.21875-26.019531-47.167969-48.121094-72.484375-64.46875-5.746094 9.644532-10.839844 19.242188-15.226563 28.671875 21.050782 14.097657 42.4375 33.019531 62.089844 55.867188 16.980469 19.738281 30.835938 40.285156 41.210938 60.238281 9.089843-4.960938 18.332031-10.789062 27.59375-17.375zm0 0"
        fill="#d8dce5"
      ></path>
      <path
        d="m376.5 50.402344c-25.132812-21.304688-89.089844 12.097656-142.851562 74.597656-23.816407 27.691406-41.632813 56.441406-51.910157 81.734375 14.457031 11.695313 28.769531 25.527344 42.265625 41.214844 6.535156 7.597656 12.609375 15.316406 18.199219 23.074219 25.921875-13.472657 55.472656-37.507813 82.457031-68.878907 53.761719-62.503906 76.972656-130.441406 51.839844-151.742187zm0 0"
        fill="#d8dce5"
      ></path>
      <path
        d="m269.757812 253.667969c-6.234374-8.753907-12.957031-17.378907-20.136718-25.789063-16.542969-19.375-34.605469-36.574218-53.203125-50.851562-5.902344 10.230468-10.820313 20.214844-14.679688 29.707031 14.457031 11.695313 28.769531 25.527344 42.261719 41.214844 6.535156 7.597656 12.609375 15.316406 18.199219 23.074219 8.847656-4.597657 18.117187-10.425782 27.558593-17.355469zm0 0"
        fill="#c3c8d1"
      ></path>
      <path
        d="m58.039062 173.832031c-33.472656 28.578125-9.398437 105.007813 49.957032 174.523438 59.355468 69.515625 131.515625 105.789062 164.988281 77.210937-69.515625 59.355469-173.984375 51.121094-233.339844-18.394531s-51.121093-173.984375 18.394531-233.339844zm0 0"
        fill="#9e6b57"
      ></path>
      <path
        d="m69.695312 407.171875c-43.007812-50.367187-50.519531-119.085937-24.957031-175.695313-4.703125-24.996093-.828125-45.582031 13.300781-57.644531-69.515624 59.355469-77.75 163.824219-18.394531 233.339844 36.253907 42.457031 89.339844 62.050781 141.007813 57.351563-41.550782-3.757813-81.726563-23.117188-110.957032-57.351563zm0 0"
        fill="#875848"
      ></path>
      <path
        d="m226.101562 247.964844c-59.351562-69.515625-134.597656-102.699219-168.070312-74.125-33.46875 28.578125-12.492188 108.097656 46.859375 177.613281s134.597656 102.703125 168.070313 74.125c33.472656-28.578125 12.492187-108.097656-46.859376-177.613281zm0 0"
        fill="#e4eaf8"
      ></path>
      <path
        d="m135.8125 351.445312c-59.355469-69.511718-80.335938-149.035156-46.867188-177.613281 4.746094-4.054687 10.335938-6.859375 16.597657-8.503906-19.257813-3.886719-35.894531-1.410156-47.503907 8.503906-33.472656 28.578125-12.488281 108.101563 46.867188 177.613281 50.9375 59.660157 113.582031 92.554688 151.480469 82.621094-36.261719-7.320312-81.804688-37.214844-120.574219-82.621094zm0 0"
        fill="#d8dce5"
      ></path>
      <path
        d="m212.503906 259.578125c-43.460937-50.90625-95.164062-78.109375-115.480468-60.761719-20.320313 17.347656-1.558594 72.675782 41.902343 123.578125 43.460938 50.90625 95.164063 78.109375 115.480469 60.761719s1.558594-72.675781-41.902344-123.578125zm0 0"
        fill="#d8dce5"
      ></path>
      <path
        d="m169.847656 322.386719c-43.464844-50.902344-62.226562-106.230469-41.910156-123.578125.851562-.730469 1.765625-1.375 2.726562-1.945313-14.1875-4.792969-26.082031-4.503906-33.632812 1.945313-20.320312 17.347656-1.554688 72.675781 41.910156 123.578125 41.636719 48.765625 90.832032 75.769531 112.757813 62.699219-23.988281-8.097657-54.546875-30.71875-81.851563-62.699219zm0 0"
        fill="#c3c8d1"
      ></path>
    </svg>
  ),
  berries: (props) => (
    <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="_24-blueberry" data-name="24-blueberry">
        <ellipse cx="14" cy="14" fill="#39285e" rx="3" ry="2"></ellipse>
        <path
          d="m25 19a11 11 0 1 1 -11-11 10.994 10.994 0 0 1 11 11zm-8-5c0-1.1-1.34-2-3-2s-3 .9-3 2 1.34 2 3 2 3-.9 3-2z"
          fill="#6f60ba"
        ></path>
        <ellipse cx="34" cy="21" fill="#39285e" rx="3" ry="2"></ellipse>
        <path
          d="m34 15a11 11 0 1 1 -11 11 10.994 10.994 0 0 1 11-11zm3 6c0-1.1-1.34-2-3-2s-3 .9-3 2 1.34 2 3 2 3-.9 3-2z"
          fill="#7e6dd4"
        ></path>
        <ellipse cx="8" cy="36" fill="#39285e" rx="2" ry="3"></ellipse>
        <path
          d="m14 25a11 11 0 1 1 -11 11 10.994 10.994 0 0 1 11-11zm-4 11c0-1.66-.9-3-2-3s-2 1.34-2 3 .9 3 2 3 2-1.34 2-3z"
          fill="#7e6dd4"
        ></path>
        <path
          d="m25 18.906c.318.064.5.094.5.094l.027-.017c.17-.206.354-.4.539-.593a7.788 7.788 0 0 0 .934-4.3s0-10.64-10.5-13.09a22.365 22.365 0 0 0 -1.4 7.055 10.991 10.991 0 0 1 9.9 10.851z"
          fill="#4e8c00"
        ></path>
        <path
          d="m34 15a10.956 10.956 0 0 1 7.643 3.1 6.921 6.921 0 0 0 2.357-5.1c0-8-2-12-2-12a84.43 84.43 0 0 0 -8.7 14.035c.232-.014.464-.035.7-.035z"
          fill="#63b300"
        ></path>
        <path
          d="m42 1c-12.946 2.774-13.92 14.091-13.993 15.781a10.932 10.932 0 0 1 5.293-1.746 84.43 84.43 0 0 1 8.7-14.035z"
          fill="#4e8c00"
        ></path>
        <ellipse cx="34" cy="21" fill="#39285e" rx="3" ry="2"></ellipse>
        <path
          d="m34 15a11 11 0 1 1 -11 11 10.994 10.994 0 0 1 11-11zm3 6c0-1.1-1.34-2-3-2s-3 .9-3 2 1.34 2 3 2 3-.9 3-2z"
          fill="#7e6dd4"
        ></path>
        <path
          d="m34 15a11 11 0 1 0 11 11 10.994 10.994 0 0 0 -11-11zm0 17c-5.527 0-10-3.578-10-8s4.473-8 10-8 10 3.578 10 8-4.473 8-10 8z"
          fill="#5f4a9e"
        ></path>
        <ellipse cx="34" cy="20.5" fill="#9883ff" rx="7" ry="4.5"></ellipse>
        <ellipse cx="34" cy="21" fill="#5f4a9e" rx="4" ry="3"></ellipse>
        <ellipse cx="34" cy="21" fill="#39285e" rx="3" ry="2"></ellipse>
        <path
          d="m34 20a3.023 3.023 0 0 1 2.893 1.5 1.367 1.367 0 0 0 .107-.5c0-1.1-1.34-2-3-2s-3 .9-3 2a1.367 1.367 0 0 0 .107.5 3.023 3.023 0 0 1 2.893-1.5z"
          fill="#261647"
        ></path>
        <path
          d="m41.526 22.005a.75.75 0 0 0 -.208.062c-.556.25-.884 1-1.28 1.439a8.132 8.132 0 0 1 -4.079 2.44 1.26 1.26 0 0 0 -.89.479.786.786 0 0 0 .237.92 2.069 2.069 0 0 0 .93.387 7.2 7.2 0 0 0 3.842.008 4.681 4.681 0 0 0 2.722-2.53 2.346 2.346 0 0 0 -.265-2.311c-.251-.414-.529-.958-1.009-.894z"
          fill="#9883ff"
        ></path>
        <ellipse cx="14" cy="14" fill="#39285e" rx="3" ry="2"></ellipse>
        <path
          d="m25 19a11 11 0 1 1 -11-11 10.994 10.994 0 0 1 11 11zm-8-5c0-1.1-1.34-2-3-2s-3 .9-3 2 1.34 2 3 2 3-.9 3-2z"
          fill="#6f60ba"
        ></path>
        <path
          d="m14 8a11 11 0 1 0 11 11 10.994 10.994 0 0 0 -11-11zm0 17c-5.527 0-10-3.578-10-8s4.473-8 10-8 10 3.578 10 8-4.473 8-10 8z"
          fill="#483584"
        ></path>
        <ellipse cx="14" cy="13.5" fill="#9883ff" rx="7" ry="4.5"></ellipse>
        <ellipse cx="14" cy="14" fill="#5f4a9e" rx="4" ry="3"></ellipse>
        <ellipse cx="14" cy="14" fill="#39285e" rx="3" ry="2"></ellipse>
        <path
          d="m14 13a3.023 3.023 0 0 1 2.893 1.5 1.367 1.367 0 0 0 .107-.5c0-1.1-1.34-2-3-2s-3 .9-3 2a1.367 1.367 0 0 0 .107.5 3.023 3.023 0 0 1 2.893-1.5z"
          fill="#261647"
        ></path>
        <path
          d="m21.526 15.005a.75.75 0 0 0 -.208.062c-.556.25-.884 1-1.28 1.439a8.132 8.132 0 0 1 -4.079 2.44 1.26 1.26 0 0 0 -.89.479.786.786 0 0 0 .237.92 2.069 2.069 0 0 0 .93.387 7.2 7.2 0 0 0 3.842.008 4.681 4.681 0 0 0 2.722-2.53 2.346 2.346 0 0 0 -.265-2.311c-.251-.414-.529-.958-1.009-.894z"
          fill="#7e6dd4"
        ></path>
        <path
          d="m7.015 27.5a10.955 10.955 0 0 1 6.985-2.5 11.764 11.764 0 0 1 -5.673-1.413 11.011 11.011 0 0 0 -2.816 2.413 11.1 11.1 0 0 0 1.504 1.5z"
          fill="#39285e"
        ></path>
        <path
          d="m23.987 16.793a11.046 11.046 0 0 0 -1.007.736 2.212 2.212 0 0 1 -.176.681 4.7 4.7 0 0 1 -2.367 2.363 10.939 10.939 0 0 0 -1.11 2.8 10.965 10.965 0 0 0 -11 .211 12.1 12.1 0 0 0 10.891.23c.153-.075.308-.149.455-.23a7.691 7.691 0 0 0 4.327-6.584c0-.07-.011-.138-.013-.207z"
          fill="#483584"
        ></path>
        <path
          d="m24.673 16.376c-.235.13-.463.271-.686.417 0 .069.013.137.013.207a7.691 7.691 0 0 1 -4.327 6.587c-.147.081-.3.155-.455.23a11.849 11.849 0 0 1 -5.218 1.183 11.132 11.132 0 0 1 6.985 2.5 11.1 11.1 0 0 0 1.5-1.5c.194-.235.374-.482.548-.733a10.934 10.934 0 0 1 1.926-5.534c.016-.243.037-.486.037-.733a11.022 11.022 0 0 0 -.323-2.624z"
          fill="#39285e"
        ></path>
        <path
          d="m22.8 18.21a2.212 2.212 0 0 0 .176-.681 11.035 11.035 0 0 0 -2.543 3.044 4.7 4.7 0 0 0 2.367-2.363z"
          fill="#5f4a9e"
        ></path>
        <ellipse cx="8" cy="36" fill="#39285e" rx="2" ry="3"></ellipse>
        <path
          d="m14 25a11 11 0 1 1 -11 11 10.994 10.994 0 0 1 11-11zm-4 11c0-1.66-.9-3-2-3s-2 1.34-2 3 .9 3 2 3 2-1.34 2-3z"
          fill="#7e6dd4"
        ></path>
        <path
          d="m3 36a11 11 0 1 0 11-11 10.994 10.994 0 0 0 -11 11zm17 0c0 5.527-3.578 10-8 10s-8-4.473-8-10 3.578-10 8-10 8 4.473 8 10z"
          fill="#5f4a9e"
        ></path>
        <ellipse cx="8.5" cy="36" fill="#9883ff" rx="4.5" ry="7"></ellipse>
        <ellipse cx="8" cy="36" fill="#5f4a9e" rx="3" ry="4"></ellipse>
        <ellipse cx="8" cy="36" fill="#39285e" rx="2" ry="3"></ellipse>
        <path
          d="m7 36a3.023 3.023 0 0 1 1.5-2.893 1.367 1.367 0 0 0 -.5-.107c-1.1 0-2 1.34-2 3s.9 3 2 3a1.367 1.367 0 0 0 .5-.107 3.023 3.023 0 0 1 -1.5-2.893z"
          fill="#261647"
        ></path>
        <path
          d="m10.8 28.407a.76.76 0 0 0 .062.208c.251.556 1.006.884 1.44 1.279a8.14 8.14 0 0 1 2.439 4.08 1.259 1.259 0 0 0 .48.89.785.785 0 0 0 .919-.237 2.069 2.069 0 0 0 .387-.93 7.2 7.2 0 0 0 .008-3.843 4.679 4.679 0 0 0 -2.53-2.725 2.346 2.346 0 0 0 -2.311.265c-.409.255-.953.532-.894 1.013z"
          fill="#9883ff"
        ></path>
        <path
          d="m25 18.906c.318.064.5.094.5.094l.027-.017c.17-.206.354-.4.539-.593a7.788 7.788 0 0 0 .934-4.3s0-10.64-10.5-13.09a22.365 22.365 0 0 0 -1.4 7.055 10.991 10.991 0 0 1 9.9 10.851z"
          fill="#4e8c00"
        ></path>
        <path
          d="m34 15a10.956 10.956 0 0 1 7.643 3.1 6.921 6.921 0 0 0 2.357-5.1c0-8-2-12-2-12a84.43 84.43 0 0 0 -8.7 14.035c.232-.014.464-.035.7-.035z"
          fill="#63b300"
        ></path>
        <path
          d="m42 1c-12.946 2.774-13.92 14.091-13.993 15.781a10.932 10.932 0 0 1 5.293-1.746 84.43 84.43 0 0 1 8.7-14.035z"
          fill="#4e8c00"
        ></path>
        <path
          d="m35.375 11.1c-.7 1.238-1.4 2.553-2.075 3.94.232-.014.464-.035.7-.035a10.956 10.956 0 0 1 7.643 3.1 8.215 8.215 0 0 0 1.59-2.062 10.989 10.989 0 0 0 -7.858-4.943z"
          fill="#4e8c00"
        ></path>
        <path
          d="m33.3 15.035c.68-1.387 1.38-2.7 2.075-3.94a11.139 11.139 0 0 0 -1.375-.095 10.944 10.944 0 0 0 -5.115 1.266 17.382 17.382 0 0 0 -.878 4.515 10.932 10.932 0 0 1 5.293-1.746z"
          fill="#3f7000"
        ></path>
        <path
          d="m15.6 4.212a31.1 31.1 0 0 0 -.5 3.843 10.991 10.991 0 0 1 9.9 10.851c.318.064.5.094.5.094l.027-.017c.17-.206.354-.4.539-.593a7.788 7.788 0 0 0 .934-4.3 14.655 14.655 0 0 0 -.59-3.618 16.555 16.555 0 0 0 -10.81-6.26z"
          fill="#3f7000"
        ></path>
        <ellipse
          cx="40"
          cy="20"
          fill="#f6fafd"
          rx="1.65"
          ry="2.297"
          transform="matrix(.707 -.707 .707 .707 -2.422 34.157)"
        ></ellipse>
        <ellipse
          cx="12"
          cy="30"
          fill="#f6fafd"
          rx="1.65"
          ry="2.297"
          transform="matrix(.707 -.707 .707 .707 -17.703 17.282)"
        ></ellipse>
        <ellipse
          cx="27"
          cy="26"
          fill="#c4b0ff"
          rx="1.65"
          ry="2.297"
          transform="matrix(.707 -.707 .707 .707 -10.476 26.72)"
        ></ellipse>
        <g fill="#f6fafd">
          <ellipse
            cx="40"
            cy="24"
            rx=".825"
            ry="1.148"
            transform="matrix(.707 -.707 .707 .707 -5.251 35.329)"
          ></ellipse>
          <ellipse
            cx="20"
            cy="15"
            rx=".825"
            ry="1.148"
            transform="matrix(.707 -.707 .707 .707 -4.748 18.544)"
          ></ellipse>
          <ellipse
            cx="19.746"
            cy="12.5"
            rx=".413"
            ry=".574"
            transform="matrix(.707 -.707 .707 .707 -3.054 17.632)"
          ></ellipse>
        </g>
      </g>
    </svg>
  ),
  citron: (props) => (
    <svg
      height="512"
      viewBox="0 0 59 59"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_3137054"
      {...props}
    >
      <g id="Page-1" fill="none" fill-rule="evenodd">
        <g id="018---Lemon" fill-rule="nonzero">
          <path
            id="Shape"
            d="m44 16c-.4793944.0006819-.8918296-.3389435-.9831224-.8095655-.0912929-.4706219.1642435-.9398227.6091224-1.1184345.384-.155 9.374-3.886 9.374-13.072 0-.55228475.4477153-1 1-1s1 .44771525 1 1c0 10.556-10.194 14.755-10.629 14.929-.1180333.0470203-.2439458.0711168-.371.071z"
            fill="#a56a43"
          ></path>
          <path
            id="Shape"
            d="m58 2h-6c-.5522847 0-1-.44771525-1-1s.4477153-1 1-1h6c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1z"
            fill="#cb8252"
          ></path>
          <path
            id="Shape"
            d="m44 15c1.3056071 1.3692021 1.4804567 3.4632339.42 5.03-.3562925.595668-.3639363 1.3371131-.02 1.94 4.93 8.69 3.02 20.72-5.3 29.04s-20.35 10.24-29.05 5.3c-.59935028-.343851-1.33790411-.3361976-1.93.02-1.5727607 1.0751552-3.67962852.9217022-5.08-.37-1.2917022-1.4003715-1.44515517-3.5072393-.37-5.08.35619763-.5920959.36385104-1.3306497.02-1.93-4.94-8.7-3.02-20.73 5.3-29.05 5.1331645-5.2779411 12.2401847-8.1678876 19.6-7.97h.01z"
            fill="#f3d55b"
          ></path>
          <path
            id="Shape"
            d="m27.93 12.37c-.1187019-.139934-.2288999-.2868647-.33-.44h-.01c-1.8249579-2.64322835-3.0158105-5.67168982-3.48-8.85-.0760176-.4927695.2225733-.96624945.7-1.11 2.2-.66 8.39-2.13 12.85.72 5.52 3.52 6.34 12.31 6.34 12.31z"
            fill="#24ae5f"
          ></path>
          <path id="Shape" d="m27.94 12.38-.01-.01" fill="#f3d55b"></path>
          <path
            id="Shape"
            d="m44 15s-3.46 8.08-9.81 9.7c-5.16 1.31-10.62-2.04-12.51-3.35-.4078841-.2852219-.5405997-.8289277-.31-1.27.83-1.65 3.07-5.54 6.56-7.71.8879465-.5594107 1.8556234-.9808728 2.87-1.25 6.36-1.62 13.2 3.88 13.2 3.88z"
            fill="#4fba6f"
          ></path>
          <g fill="#f0c419">
            <circle id="Oval" cx="7" cy="32" r="1"></circle>
            <circle id="Oval" cx="13" cy="31" r="1"></circle>
            <circle id="Oval" cx="16" cy="35" r="1"></circle>
            <circle id="Oval" cx="9" cy="43" r="1"></circle>
            <circle id="Oval" cx="17" cy="28" r="1"></circle>
            <circle id="Oval" cx="10" cy="37" r="1"></circle>
            <circle id="Oval" cx="5" cy="39" r="1"></circle>
            <circle id="Oval" cx="11" cy="26" r="1"></circle>
          </g>
        </g>
      </g>
    </svg>
  ),
};
